(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[645],{

/***/ 51733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgTickIcon = function SvgTickIcon(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: "512pt",
    height: "512pt",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M256 12.801c-134.14 0-243.2 109.05-243.2 243.2s109.05 243.2 243.2 243.2 243.2-109.05 243.2-243.2-109.05-243.2-243.2-243.2zm108.03 203.77L251.9 337.401c-5.633 6.144-13.824 9.727-22.527 9.727s-16.383-3.586-22.527-9.727l-58.879-64c-11.266-12.289-10.754-31.742 1.535-43.52 12.29-11.266 31.742-10.754 43.52 1.535l36.863 39.426 89.602-96.77c11.777-12.289 30.72-12.8 43.52-1.535 11.777 12.289 12.801 31.746 1.024 44.031z",
    fill: "#fff"
  })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgTickIcon);

/***/ }),

/***/ 31318:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organisation-settings",
      function () {
        return __webpack_require__(23241);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const LoadingBar = ()=>{
    const shimmerStyle = {
        backgroundSize: "200% 100%",
        animation: "shimmer 1.5s infinite"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-2 bg-blue-100 overflow-hidden relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full h-full absolute transform translate-x-0 bg-gradient-to-r from-transparent via-blue-500 to-transparent",
            style: shimmerStyle
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingBar);


/***/ }),

/***/ 12172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ RadioFieldInput; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Validations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6686);




/**
 * Primary UI component for radio inputs.
 */ const RadioFieldInput = (param)=>{
    let { label , value ="" , onChange , className , hint , validations , required , options , testid , itemClassName =""  } = param;
    const errorMessage = (0,_Validations__WEBPACK_IMPORTED_MODULE_3__/* .validate */ .G)(value, validations);
    const inputName = label === null || label === void 0 ? void 0 : label.toString().toLowerCase().trim().replaceAll(" ", "_");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("fieldset", {
        className: [
            "flex flex-col gap-3",
            className
        ].join(" "),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("legend", {
                className: "text-sm font-medium text-[#153e3e] transition-all ".concat(errorMessage ? "text-red-500" : ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: required ? "after:content-['*'] after:ml-1 after:text-red-500" : "",
                        children: label
                    }),
                    hint ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "ml-2 text-xs font-normal",
                        children: hint
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                className: "flex flex-col gap-3 sm:flex-row sm:flex-wrap",
                children: options === null || options === void 0 ? void 0 : options.map((option, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        className: "".concat(itemClassName, " flex cursor-pointer items-center gap-2 text-sm font-medium text-[#153e3e]"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                "data-testid": testid ? "".concat(testid, "-").concat(i) : null,
                                type: "radio",
                                className: "peer sr-only",
                                name: inputName,
                                value: option,
                                checked: value === option,
                                onChange: (e)=>{
                                    onChange && onChange(e.target.value, false);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                "aria-hidden": "true",
                                className: "h-[18px] w-[18px] shrink-0 rounded-full border-2 border-[#153e3e] bg-transparent transition-all peer-checked:border-[5px] peer-focus-visible:ring-2 peer-focus-visible:ring-[#153e3e]/30"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "min-w-0",
                                children: option
                            })
                        ]
                    }, option))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
                ignoreTheme: true,
                className: "transition-all ".concat(errorMessage ? "opacity-100" : "opacity-0", " text-red-500 text-sm font-bold"),
                children: errorMessage !== null && errorMessage !== void 0 ? errorMessage : "-"
            })
        ]
    });
};


/***/ }),

/***/ 4893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ GET_MEMBERSHIP_FOR_ORGANISATION; }
/* harmony export */ });
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66703);

const GET_MEMBERSHIP_FOR_ORGANISATION = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  query GetMembershipOptionsForOrganisation($data: String!) {\n    getMembershipForOrganisation(organisationName: $data) {\n      __typename\n\n      ... on GetMembershipOutput {\n        details {\n          isPublished\n          title\n          bannerImage\n          thumbnailImage\n          description\n          shortDescription\n          confirmationText\n          membershipId\n          emailTemplates {\n            title\n            data\n            trigger\n            content\n            sentDateTime\n          }\n        }\n        product {\n          productId\n          prices {\n            priceAmount\n            priceId\n            interval\n            currency\n            title\n            pillText\n          }\n          name\n        }\n      }\n\n      ... on APIError {\n        error\n        code\n      }\n    }\n  }\n");


/***/ }),

/***/ 41826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ UPDATE_ORGANISATION; }
/* harmony export */ });
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66703);

const UPDATE_ORGANISATION = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  mutation updateOrganisation(\n    $name: String!\n    $organisationType: String\n    $mainColour: String\n    $bannerImage: String\n    $logoImage: String\n    $currency: String\n    $percentage: Float\n    $headerTextOne: String\n    $headerTextTwo: String\n    $dashboardPopupDoNotShowAgain: Boolean\n  ) {\n    updateOrganisation(\n      name: $name\n      organisationType: $organisationType\n      mainColour: $mainColour\n      bannerImage: $bannerImage\n      logoImage: $logoImage\n      currency: $currency\n      percentage: $percentage\n      headerTextOne: $headerTextOne\n      headerTextTwo: $headerTextTwo\n      dashboardPopupDoNotShowAgain: $dashboardPopupDoNotShowAgain\n    ) {\n      success\n    }\n  }\n");


/***/ }),

/***/ 99591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pu": function() { return /* binding */ DISCONNECT_PAYMENT_PROCESSOR; },
/* harmony export */   "QF": function() { return /* binding */ GET_PAYMENT_SETTINGS; },
/* harmony export */   "jL": function() { return /* binding */ COMPLETE_GOCARDLESS_CONNECTION; },
/* harmony export */   "mR": function() { return /* binding */ GET_PAYMENT_PROCESSOR_DISCONNECT_IMPACT; },
/* harmony export */   "n_": function() { return /* binding */ CREATE_PAYMENT_PROCESSOR_CONNECT_LINK; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68806);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetPaymentSettings {\n    getPaymentSettings {\n      stripe {\n        processor\n        configured\n        ready\n        organisationId\n        reason\n      }\n      gocardless {\n        processor\n        configured\n        ready\n        organisationId\n        reason\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CreatePaymentProcessorConnectLink($processor: PaymentProcessor!) {\n    createPaymentProcessorConnectLink(processor: $processor) {\n      redirectUrl\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CompleteGoCardlessConnection(\n    $input: CompleteGoCardlessConnectionInput!\n  ) {\n    completeGoCardlessConnection(input: $input) {\n      success\n      error\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetPaymentProcessorDisconnectImpact($processor: PaymentProcessor!) {\n    getPaymentProcessorDisconnectImpact(processor: $processor) {\n      eventId\n      title\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DisconnectPaymentProcessor($processor: PaymentProcessor!) {\n    disconnectPaymentProcessor(processor: $processor)\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}

const GET_PAYMENT_SETTINGS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
const CREATE_PAYMENT_PROCESSOR_CONNECT_LINK = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
const COMPLETE_GOCARDLESS_CONNECTION = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
const GET_PAYMENT_PROCESSOR_DISCONNECT_IMPACT = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
const DISCONNECT_PAYMENT_PROCESSOR = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());


/***/ }),

/***/ 77223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J9": function() { return /* binding */ GET_ORGANISATION_ORGANISER_INVITE; },
/* harmony export */   "V$": function() { return /* binding */ GET_ORGANISATION_ORGANISERS; },
/* harmony export */   "bV": function() { return /* binding */ UPDATE_ORGANISATION_ORGANISER_ROLE; },
/* harmony export */   "be": function() { return /* binding */ DECLINE_ORGANISATION_ORGANISER_INVITE; },
/* harmony export */   "gE": function() { return /* binding */ REMOVE_ORGANISATION_ORGANISER; },
/* harmony export */   "nf": function() { return /* binding */ CANCEL_ORGANISATION_ORGANISER_INVITE; },
/* harmony export */   "to": function() { return /* binding */ ACCEPT_ORGANISATION_ORGANISER_INVITE; },
/* harmony export */   "x3": function() { return /* binding */ INVITE_ORGANISATION_ORGANISER; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68806);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetOrganisationOrganisers($organisationName: String!) {\n    getOrganisationOrganisers(organisationName: $organisationName) {\n      organisers {\n        userId\n        email\n        name\n        profileImage\n        jobTitle\n        company\n        companyTitle\n        university\n        permissions\n        role\n      }\n      pendingInvites {\n        inviteId\n        organisationName\n        email\n        name\n        role\n        status\n        createdAt\n        expiresAt\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetOrganisationOrganiserInvite($inviteId: String!) {\n    getOrganisationOrganiserInvite(inviteId: $inviteId) {\n      inviteId\n      organisationName\n      email\n      name\n      role\n      status\n      createdAt\n      expiresAt\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation InviteOrganisationOrganiser(\n    $input: InviteOrganisationOrganiserInput!\n  ) {\n    inviteOrganisationOrganiser(input: $input) {\n      success\n      inviteId\n      userId\n      status\n    }\n  }\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation RemoveOrganisationOrganiser(\n    $input: RemoveOrganisationOrganiserInput!\n  ) {\n    removeOrganisationOrganiser(input: $input) {\n      success\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation UpdateOrganisationOrganiserRole(\n    $input: UpdateOrganisationOrganiserRoleInput!\n  ) {\n    updateOrganisationOrganiserRole(input: $input) {\n      success\n      role\n      permissions\n    }\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation CancelOrganisationOrganiserInvite($inviteId: String!) {\n    cancelOrganisationOrganiserInvite(inviteId: $inviteId) {\n      success\n    }\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation AcceptOrganisationOrganiserInvite($inviteId: String!) {\n    acceptOrganisationOrganiserInvite(inviteId: $inviteId) {\n      success\n      inviteId\n      userId\n      status\n    }\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation DeclineOrganisationOrganiserInvite($inviteId: String!) {\n    declineOrganisationOrganiserInvite(inviteId: $inviteId) {\n      success\n    }\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}

const GET_ORGANISATION_ORGANISERS = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
const GET_ORGANISATION_ORGANISER_INVITE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
const INVITE_ORGANISATION_ORGANISER = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
const REMOVE_ORGANISATION_ORGANISER = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
const UPDATE_ORGANISATION_ORGANISER_ROLE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
const CANCEL_ORGANISATION_ORGANISER_INVITE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());
const ACCEPT_ORGANISATION_ORGANISER_INVITE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6());
const DECLINE_ORGANISATION_ORGANISER_INVITE = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject7());


/***/ }),

/***/ 16458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zo": function() { return /* binding */ getBankingCountryByPaymentMethod; },
  "Ip": function() { return /* binding */ getDonationTotal; },
  "T3": function() { return /* binding */ getStripeConnectStatus; }
});

// UNUSED EXPORTS: getProcessorFees

;// CONCATENATED MODULE: ./libs/Stripe/processor-fees.ts
//Flat values are represented as the unit for said currency (GBP = pence, USD = cent).
const processor_fees_EUROPE_ECONOMIC_AREA = (/* unused pure expression or super */ null && ([
    "AT",
    "BE",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "DE",
    "GI",
    "GR",
    "HU",
    "IS",
    "IE",
    "IT",
    "LV",
    "LI",
    "LT",
    "LU",
    "MT",
    "NL",
    "NO",
    "PL",
    "PT",
    "RO",
    "SK",
    "SI",
    "ES",
    "SE"
]));
const processor_fees_STRIPE_PAYMENT_FEES = {
    GBP: {
        percent: 1.5,
        flat: 20
    },
    EEA: {
        percent: 2.5,
        flat: 20
    },
    INTERNATIONAL: {
        percent: 3.25,
        flat: 20
    }
};

;// CONCATENATED MODULE: ./libs/Stripe/util.ts

const getStripeConnectStatus = (merchantAccount)=>{
    var ref;
    const required = (ref = merchantAccount === null || merchantAccount === void 0 ? void 0 : merchantAccount.required) !== null && ref !== void 0 ? ref : [];
    const isMerchant = !!(merchantAccount === null || merchantAccount === void 0 ? void 0 : merchantAccount.merchantAccountExists);
    const chargesEnabled = !!(merchantAccount === null || merchantAccount === void 0 ? void 0 : merchantAccount.chargesEnabled);
    const onboardingComplete = isMerchant && required.length < 1;
    return {
        isMerchant,
        chargesEnabled,
        onboardingComplete,
        required,
        isReady: isMerchant && chargesEnabled && onboardingComplete
    };
};
const getBankingCountryByPaymentMethod = (paymentMethod)=>{
    if (!paymentMethod) return undefined;
    const { type , card  } = paymentMethod;
    var ref;
    return (ref = card === null || card === void 0 ? void 0 : card.country) !== null && ref !== void 0 ? ref : undefined;
};
const getProcessorFees = (regionCode)=>{
    if (!regionCode) return STRIPE_PAYMENT_FEES.INTERNATIONAL;
    if (regionCode === "GB") return STRIPE_PAYMENT_FEES.GBP;
    if (EUROPE_ECONOMIC_AREA.includes(regionCode)) return STRIPE_PAYMENT_FEES.EEA;
    return STRIPE_PAYMENT_FEES.INTERNATIONAL;
};
const getDonationTotal = (param)=>{
    let { amount , platformFee , regionCode , coverPlatformFee  } = param;
    let donationAmountCents = amount;
    let totalDonationCents = amount;
    const platformFeeAmountCents = Math.ceil(donationAmountCents * (platformFee / 100));
    if (coverPlatformFee) {
        totalDonationCents = donationAmountCents + platformFeeAmountCents;
    }
    donationAmountCents = totalDonationCents - platformFeeAmountCents;
    return {
        donation: donationAmountCents,
        platformFee: platformFeeAmountCents,
        total: totalDonationCents,
        regionCode
    };
};


/***/ }),

/***/ 30530:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const currencies = {
    CAD: {
        symbol: "$",
        name: "Canadian Dollar"
    },
    USD: {
        symbol: "$",
        name: "US Dollar"
    },
    EUR: {
        symbol: "€",
        name: "Euro"
    },
    GBP: {
        symbol: "\xa3",
        name: "British Pound"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (currencies);


/***/ }),

/***/ 52992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ isGoCardlessEnabled; }
/* harmony export */ });
const isGoCardlessEnabled = ()=>{
    var ref;
    return ((ref = "false") === null || ref === void 0 ? void 0 : ref.trim().toLowerCase()) === "true";
};


/***/ }),

/***/ 5834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ useBlackBaud; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/crypto-browserify/index.js
var crypto_browserify = __webpack_require__(42474);
var crypto_browserify_default = /*#__PURE__*/__webpack_require__.n(crypto_browserify);
// EXTERNAL MODULE: ./libs/useLocalStorage.tsx
var useLocalStorage = __webpack_require__(3830);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/organisation/connectToBlackBaud.ts

const CONNECT_TO_BLACKBAUD = (0,_generated/* graphql */.B)("\n  mutation connectToBlackBaud(\n    $name: String!\n    $code: String!\n    $codeVerifier: String!\n    $clientId: String!\n    $redirectUri: String!\n  ) {\n    connectToBlackBaud(\n      name: $name\n      code: $code\n      codeVerifier: $codeVerifier\n      clientId: $clientId\n      redirectUri: $redirectUri\n    ) {\n      success\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/events/pushToBlackbaud.ts

const PUSH_TO_BLACKBAUD = (0,_generated/* graphql */.B)("\n  mutation pushToBlackbaud(\n    $eventId: String!\n    $blackbaudId: String\n    $fields: [String!]!\n    $updatedConstituents: [UpdatedConstituentInput!]\n  ) {\n    pushToBlackbaud(\n      eventId: $eventId\n      blackbaudId: $blackbaudId\n      fields: $fields\n      updatedConstituents: $updatedConstituents\n    ) {\n      success\n      completed\n      error\n      isOrganizer\n      blackBaudAccessToken\n      orgName\n      currentBlackbaudId\n      newBlackbaudId\n      bbServiceInitialized\n      bbPrimaryAccessKey\n      bbUrl\n      eventPreUpdate\n      eventPostUpdate\n      eventUpdated\n      eventId\n    }\n  }\n");

;// CONCATENATED MODULE: ./graphql/events/getBlackBaudEventQuery.ts

const GET_BLACKBAUD_EVENT_BY_ID = (0,_generated/* graphql */.B)("\n  mutation getBlackBaudEvent($eventId: String!, $blackbaudId: String) {\n    getBlackBaudEvent(eventId: $eventId, blackbaudId: $blackbaudId) {\n      id\n      name\n      description\n      start_date\n      start_time\n      end_date\n      end_time\n      attendees {\n        name\n        email\n        summary_note\n        contact_id\n      }\n      speakers {\n        name\n        email\n        summary_note\n        contact_id\n      }\n    }\n  }\n");

;// CONCATENATED MODULE: ./libs/useBlackBaud.ts







const CLIENT_ID = "147edada-78d2-41da-8684-ab05ee42132c";
const REDIRECT_URI = "https://app.forumm.to/organisation-settings";
const useBlackBaud = ()=>{
    const [connectToBlackBaud] = (0,useMutation/* useMutation */.D)(CONNECT_TO_BLACKBAUD);
    const [pushToBlackbaud] = (0,useMutation/* useMutation */.D)(PUSH_TO_BLACKBAUD);
    const [getBlackBaudEvent] = (0,useMutation/* useMutation */.D)(GET_BLACKBAUD_EVENT_BY_ID);
    const [accessToken, setAccessToken] = (0,react.useState)(null);
    const [completed, setCompleted] = (0,react.useState)(false);
    const [lsCodeVerifier, setCodeVerifier] = (0,useLocalStorage/* default */.Z)("BlackBaud_CodeVerifier", "");
    const base64URLEncode = (str)=>{
        return str.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    };
    const initiateOAuth = (0,react.useCallback)(()=>{
        const newState = crypto_browserify_default().randomBytes(48).toString("hex");
        const codeVerifier = base64URLEncode(crypto_browserify_default().randomBytes(32));
        setCodeVerifier(codeVerifier);
        const challengeDigest = crypto_browserify_default().createHash("sha256").update(codeVerifier).digest();
        const newCodeChallenge = base64URLEncode(challengeDigest);
        const authUrl = "https://app.blackbaud.com/oauth/authorize?response_type=code&client_id=".concat(CLIENT_ID, "&redirect_uri=").concat(encodeURIComponent(REDIRECT_URI), "&state=").concat(newState, "&code_challenge=").concat(newCodeChallenge, "&code_challenge_method=S256");
        window.location.href = authUrl;
    }, []);
    const onCallback = (0,react.useCallback)(async (url, name, onCompleteAction)=>{
        if (completed) return;
        const urlParams = new URLSearchParams(new URL(url).search);
        const code = urlParams.get("code");
        let error = urlParams.get("error");
        if (error || !code) {
            console.error("Error during authentication: ", error);
            return;
        }
        const response = await connectToBlackBaud({
            variables: {
                codeVerifier: lsCodeVerifier,
                clientId: CLIENT_ID,
                redirectUri: REDIRECT_URI,
                code,
                name
            }
        });
        if (onCompleteAction) {
            setTimeout(()=>{
                onCompleteAction();
            }, 100);
        }
        setCompleted(true);
    }, // eslint-disable-next-line
    [
        connectToBlackBaud,
        completed,
        setCompleted
    ]);
    const publish = (0,react.useCallback)(async (eventId, fields, updatedConstituents, blackbaudId)=>{
        console.log("WILL PUBLISH:", {
            eventId,
            fields,
            blackbaudId,
            updatedConstituents
        });
        return await pushToBlackbaud({
            variables: {
                eventId,
                fields,
                blackbaudId,
                updatedConstituents
            }
        });
    }, [
        pushToBlackbaud
    ]);
    const getEvent = (0,react.useCallback)(async (eventId, blackbaudId)=>{
        const response = await getBlackBaudEvent({
            variables: {
                eventId,
                blackbaudId
            }
        });
        return response;
    }, [
        pushToBlackbaud
    ]);
    return {
        initiateOAuth,
        onCallback,
        accessToken,
        completed,
        publish,
        getEvent
    };
};


/***/ }),

/***/ 11734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ libs_useFileUploader; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/media/uploadMedia.ts

const UPLOAD_MEDIA = (0,_generated/* graphql */.B)("\n  mutation UploadMedia($input: MediaUploadInput!) {\n    uploadMedia(input: $input) {\n      preSignedUrl\n      uploadedFileUrl\n    }\n  }\n");

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
;// CONCATENATED MODULE: ./libs/useFileUploader.ts



const useFileUploader = ()=>{
    const [uploadMedia] = (0,useMutation/* useMutation */.D)(UPLOAD_MEDIA);
    const generateSafeFileName = (name)=>{
        return (0,v4/* default */.Z)();
    };
    const uploadFile = async (file)=>{
        var ref, ref1;
        const response = await uploadMedia({
            variables: {
                input: {
                    contentType: "application/x-www-form-urlencoded",
                    filename: generateSafeFileName(file.name)
                }
            }
        });
        const preSignedUrl = (ref = response.data) === null || ref === void 0 ? void 0 : ref.uploadMedia.preSignedUrl;
        const uploadedFileUrl = (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.uploadMedia.uploadedFileUrl;
        await fetch(preSignedUrl, {
            method: "PUT",
            body: file,
            headers: {
                "Content-Type": file.type
            }
        });
        return uploadedFileUrl !== null && uploadedFileUrl !== void 0 ? uploadedFileUrl : "";
    };
    return uploadFile;
};
/* harmony default export */ var libs_useFileUploader = (useFileUploader);


/***/ }),

/***/ 23241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ UserDetailsPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./libs/Auth/useAuth.ts + 3 modules
var useAuth = __webpack_require__(24499);
// EXTERNAL MODULE: ./components/base/LoadingBar.tsx
var LoadingBar = __webpack_require__(623);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js + 1 modules
var useMutation = __webpack_require__(72742);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 2 modules
var useQuery = __webpack_require__(6812);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(73359);
// EXTERNAL MODULE: ./graphql/organisation/updateOrganisation.ts
var organisation_updateOrganisation = __webpack_require__(41826);
// EXTERNAL MODULE: ./graphql/organisation/getOrganisationByName.ts
var getOrganisationByName = __webpack_require__(7921);
// EXTERNAL MODULE: ./graphql/__generated/index.ts + 1 modules
var _generated = __webpack_require__(66703);
;// CONCATENATED MODULE: ./graphql/organisation/zapier.ts

const GET_ZAPIER_INTEGRATION_STATUS = (0,_generated/* graphql */.B)("\n  query getZapierIntegrationStatus($name: String!) {\n    getZapierIntegrationStatus(name: $name) {\n      connected\n      hasApiToken\n      tokenLastFour\n      createdAt\n      activeSubscriptionCount\n    }\n  }\n");
const CREATE_ZAPIER_API_TOKEN = (0,_generated/* graphql */.B)("\n  mutation createZapierApiToken($name: String!) {\n    createZapierApiToken(name: $name) {\n      success\n      token\n      tokenLastFour\n      createdAt\n      error\n    }\n  }\n");
const REVOKE_ZAPIER_INTEGRATION = (0,_generated/* graphql */.B)("\n  mutation revokeZapierIntegration($name: String!) {\n    revokeZapierIntegration(name: $name) {\n      success\n    }\n  }\n");

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./components/inputs/FileInput.tsx + 5 modules
var FileInput = __webpack_require__(40296);
// EXTERNAL MODULE: ./components/inputs/ColorPicker.tsx + 1 modules
var ColorPicker = __webpack_require__(14857);
// EXTERNAL MODULE: ./libs/useFileUploader.ts + 1 modules
var useFileUploader = __webpack_require__(11734);
// EXTERNAL MODULE: ./public/images/TickIcon.svg
var TickIcon = __webpack_require__(51733);
// EXTERNAL MODULE: ./libs/useTheme.ts + 1 modules
var useTheme = __webpack_require__(5779);
// EXTERNAL MODULE: ./components/inputs/RadioFieldInput.tsx
var RadioFieldInput = __webpack_require__(12172);
// EXTERNAL MODULE: ./libs/useBlackBaud.ts + 3 modules
var useBlackBaud = __webpack_require__(5834);
// EXTERNAL MODULE: ./components/base/Modal.tsx
var Modal = __webpack_require__(18860);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(47516);
;// CONCATENATED MODULE: ./graphql/users/getMerchantAccount.ts

const GET_IS_MERCHANT = (0,_generated/* graphql */.B)("\n  query GetMerchantAccount($input: GetMerchantAccountInput!) {\n    getMerchantAccount(input: $input) {\n      merchantAccountExists\n      chargesEnabled\n      required\n    }\n  }\n");

// EXTERNAL MODULE: ./libs/paymentFeatureFlags.ts
var paymentFeatureFlags = __webpack_require__(52992);
// EXTERNAL MODULE: ./components/base/Tabs.tsx
var Tabs = __webpack_require__(85026);
;// CONCATENATED MODULE: ./components/base/SideNav.tsx


const SideNav = (param)=>{
    let { className , navItems , stage , disabled , setStage  } = param;
    const selectedIndex = navItems.findIndex((items)=>items.targetStage === stage);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex items-end md:items-start flex-row md:flex-col cursor-pointer max-w-[100vw] ".concat(className),
        children: navItems.map((item)=>{
            const { label , targetStage  } = item;
            const isActive = targetStage === stage;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col items-center mx-1 md:mx-0",
                    onClick: ()=>{
                        if (!disabled) setStage(targetStage);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm mt-4 text-right ".concat(isActive ? "font-bold underline" : ""),
                        children: label
                    })
                })
            }, "sidenav-item-".concat(item.label));
        })
    });
};
/* harmony default export */ var base_SideNav = (SideNav);

// EXTERNAL MODULE: ./components/base/LoadingSpinner.tsx + 1 modules
var LoadingSpinner = __webpack_require__(38999);
// EXTERNAL MODULE: ./components/base/Text.tsx
var Text = __webpack_require__(40517);
// EXTERNAL MODULE: ./components/inputs/TextInput.tsx
var TextInput = __webpack_require__(39618);
// EXTERNAL MODULE: ./graphql/users/GetUsersByIds.ts
var GetUsersByIds = __webpack_require__(50116);
;// CONCATENATED MODULE: ./graphql/events/updateOrder.ts

const UPDATE_ORDER = (0,_generated/* graphql */.B)("\n  mutation UpdateOrder($input: UpdateOrderInput!) {\n    updateOrder(input: $input)\n  }\n");

;// CONCATENATED MODULE: ./components/order-manager/MemberModal.tsx




const MemberModal = (props)=>{
    const { data , onComplete , className  } = props;
    const [modalData, setModalData] = (0,react.useState)(data);
    const [tab, setTab] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (data) setModalData(data);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        className: "flex flex-col items-center mt-14 text-white w-full ".concat(className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "flex flex-col justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex-1 text-sm md:text-base break-all p-2",
                    children: [
                        "Member Email: ",
                        modalData === null || modalData === void 0 ? void 0 : modalData.customerEmail
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex-1 text-sm md:text-base break-all p-2",
                    children: [
                        "Status: ",
                        (modalData === null || modalData === void 0 ? void 0 : modalData.paid) ? "ACTIVE" : "INACTIVE"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex-1 text-sm md:text-base break-all p-2",
                    children: [
                        "Last Renewal: ",
                        modalData === null || modalData === void 0 ? void 0 : modalData.lastUpdated
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex-1 text-sm md:text-base break-all p-2",
                    children: [
                        "Stripe Price ID: ",
                        modalData === null || modalData === void 0 ? void 0 : modalData.priceId
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex-1 text-sm md:text-base break-all p-2",
                    children: [
                        "Order ID: ",
                        modalData === null || modalData === void 0 ? void 0 : modalData.orderId
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var order_manager_MemberModal = (MemberModal);

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./components/metrics/TableMembers.tsx












const getFiltered = (orders, filter)=>{
    if (!filter || !orders) return orders;
    const lowercasedSearchText = filter.toLowerCase();
    const payload = orders.filter((order)=>{
        var ref;
        const orderEmail = order === null || order === void 0 ? void 0 : order.customerEmail;
        return (orderEmail === null || orderEmail === void 0 ? void 0 : orderEmail.includes(lowercasedSearchText)) || (order === null || order === void 0 ? void 0 : order.orderId.includes(lowercasedSearchText)) || (order === null || order === void 0 ? void 0 : (ref = order.userId) === null || ref === void 0 ? void 0 : ref.includes(lowercasedSearchText));
    });
    return payload;
};
const TableMembers = (param)=>{
    let { orders , className , refetch  } = param;
    const { profile  } = (0,useAuth/* useAuth */.aC)();
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const isDarkTheme = theme.type === "DARK";
    var ref;
    const org = (ref = profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref !== void 0 ? ref : profile === null || profile === void 0 ? void 0 : profile.university;
    const [filter, setFilter] = (0,react.useState)("");
    const [users, setUsers] = (0,react.useState)([]);
    // const [memberData, setMemberData] = useState<SubscriptionOrder[]>([])
    const orderUsers = orders === null || orders === void 0 ? void 0 : orders.map((o)=>{
        return o === null || o === void 0 ? void 0 : o.userId;
    }).filter((o)=>!!o);
    // const { loading: membersLoading } = useQuery(
    //   GET_ACTIVE_MEMBERSHIPS_BY_COMPANY,
    //   {
    //     variables: { organisationName: profile?.company! },
    //     skip: !profile?.company,
    //     onCompleted: (data) => {
    //       const payload = data.getActiveMembershipsByCompany
    //       setMemberData(payload)
    //     },
    //   }
    // )
    const { loading: usersLoading  } = (0,useQuery/* useQuery */.a)(GetUsersByIds/* GET_USERS_BY_IDS */.B, {
        variables: {
            input: {
                userIds: orderUsers
            }
        },
        skip: orderUsers.length < 1,
        onCompleted: (data)=>{
            setUsers(data.getUsersByIds.items);
        }
    });
    const filteredData = (0,react.useMemo)(()=>{
        return getFiltered(orders, filter).map((o)=>{
            const user = users.find((u)=>{
                return u.userId === (o === null || o === void 0 ? void 0 : o.userId);
            });
            // const event = eventsData.find((e) => e.eventId === o?.eventId)
            const payload = {
                ...o,
                user
            };
            return payload;
        });
    }, [
        orders,
        filter,
        users
    ]);
    const [isOrderModalOpen, setOrderModalOpen] = (0,react.useState)(false);
    const [orderModalData, setOrderModalData] = (0,react.useState)();
    const [updateOrder] = (0,useMutation/* useMutation */.D)(UPDATE_ORDER);
    const handleSubmit = (data)=>{
        if (data.orderId) {
            updateOrder({
                variables: {
                    input: {
                        orderId: data.orderId,
                        paid: data.paid
                    }
                }
            }).then(()=>refetch());
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(order_manager_MemberModal, {
                show: isOrderModalOpen,
                setShow: setOrderModalOpen,
                className: "max-w-md",
                title: "Member Manager",
                data: orderModalData,
                onComplete: (data)=>handleSubmit(data)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "w-full flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    color: "foregroundColour",
                    className: "flex-2 rounded-3xl border shadow-md border-forumm-menu-border p-3 sm:p-5 max-w-[1500px] justify-center items-center ".concat(className),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "flex flex-col md:flex-row w-full justify-between items-center mb-8",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    className: "text-xl text-center md:text-left",
                                    children: "".concat(org, "'s Members")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "mt-4 md:mt-0 md:min-w-[300px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                        value: filter,
                                        className: "w-full",
                                        placeholder: "Enter your search terms",
                                        onChange: setFilter
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "max-h-[300px] overflow-y-scroll scrollbar-hide",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "w-full flex flex-row ".concat(isDarkTheme ? "bg-dark" : "bg-forumm-light-gray", " rounded-t-xl py-2 mb-5"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "flex-3 font-bold text-sm md:text-base",
                                            children: "User Email"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "flex-3 font-bold text-start text-sm sm:text-base ml-4",
                                            children: "Order ID"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "flex-1 text-center font-bold text-sm md:text-base",
                                            children: "Active"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "flex-1 text-center font-bold text-sm md:text-base",
                                            children: "Last Paid"
                                        })
                                    ]
                                }),
                                filteredData.map((orderData, index)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "flex flex-row items-center cursor-pointer ".concat(index % 2 === 0 ? "bg-gray-50" : "bg-white"),
                                        onClick: ()=>{
                                            setOrderModalOpen(true);
                                            setOrderModalData(orderData);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "flex-3 text-sm md:text-base break-all p-2",
                                                children: orderData.customerEmail
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "flex-3 flex flex-row text-start justify-start text-sm md:text-base ml-4 break-all p-2",
                                                children: orderData === null || orderData === void 0 ? void 0 : orderData.orderId
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "flex-1 text-center text-sm md:text-base ".concat((orderData === null || orderData === void 0 ? void 0 : orderData.paid) ? "border border-green-300" : "border border-yellow-300", " rounded-xl"),
                                                children: (orderData === null || orderData === void 0 ? void 0 : orderData.paid) ? "ACTIVE" : "INACTIVE"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "flex-1 text-center text-sm md:text-base",
                                                children: orderData.lastUpdated ? moment_default()(orderData === null || orderData === void 0 ? void 0 : orderData.lastUpdated).format("DD/MM/YYYY") : ""
                                            })
                                        ]
                                    }, orderData.orderId);
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var metrics_TableMembers = (TableMembers);

;// CONCATENATED MODULE: ./graphql/events/GetEventsByIds.ts

const GET_EVENTS_BY_IDS = (0,_generated/* graphql */.B)("\n  query getEventsByIds($eventIds: [String!]!) {\n    getEventsByIds(eventIds: $eventIds) {\n      ...EventFull\n    }\n  }\n");

// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
;// CONCATENATED MODULE: ./components/order-manager/OrderModal.tsx







const getTicketTypeSelection = (orderedTicketTitle, eventTicketTypes)=>{
    const normalizedOrderedTitle = orderedTicketTitle.trim().toUpperCase();
    const matchingEventTicket = eventTicketTypes.find((ticket)=>ticket.title.trim().toUpperCase() === normalizedOrderedTitle);
    const eventOptions = eventTicketTypes.map((param)=>{
        let { title  } = param;
        return {
            title
        };
    });
    if (matchingEventTicket) {
        return {
            selectedTitle: matchingEventTicket.title,
            options: eventOptions
        };
    }
    return {
        selectedTitle: orderedTicketTitle,
        options: orderedTicketTitle ? [
            {
                title: orderedTicketTitle,
                isUnavailable: true
            },
            ...eventOptions
        ] : eventOptions
    };
};
const paymentStatusStyles = {
    SUCCEEDED: "bg-emerald-100 text-emerald-800 border-emerald-200",
    PENDING: "bg-amber-100 text-amber-900 border-amber-200",
    FAILED: "bg-red-100 text-red-800 border-red-200",
    REFUNDED: "bg-slate-200 text-slate-800 border-slate-300",
    CHARGED_BACK: "bg-red-100 text-red-800 border-red-200"
};
const Identifier = (param)=>/*#__PURE__*/ {
    let { label , value , copied , onCopy  } = param;
    return (0,jsx_runtime.jsxs)(Box["default"], {
        className: "min-w-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "text-xs font-semibold uppercase tracking-wide opacity-60",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "mt-1 flex min-w-0 items-center gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                        className: "truncate text-xs sm:text-sm",
                        title: value !== null && value !== void 0 ? value : "Not available",
                        children: value !== null && value !== void 0 ? value : "Not available"
                    }),
                    !!value && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        "aria-label": "Copy ".concat(label),
                        title: "Copy ".concat(label),
                        className: "shrink-0 cursor-pointer rounded-md p-1.5 opacity-70 transition-colors hover:bg-black/5 hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forumm-blue",
                        onClick: onCopy,
                        children: copied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdCheck */.HhX, {
                            "aria-hidden": "true",
                            className: "h-4 w-4"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdContentCopy */.Fqs, {
                            "aria-hidden": "true",
                            className: "h-4 w-4"
                        })
                    })
                ]
            })
        ]
    });
};
const OrderModal = (param)=>{
    let { data , onComplete , className , setShow , ...modalProps } = param;
    var ref, ref1, ref2;
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const [modalData, setModalData] = (0,react.useState)(data);
    const [activeTicketIndex, setActiveTicketIndex] = (0,react.useState)(0);
    const [copiedIdentifier, setCopiedIdentifier] = (0,react.useState)();
    (0,react.useEffect)(()=>{
        setModalData(data);
        setActiveTicketIndex(0);
        setCopiedIdentifier(undefined);
    }, [
        data
    ]);
    var ref3;
    const tickets = (ref3 = modalData === null || modalData === void 0 ? void 0 : modalData.tickets) !== null && ref3 !== void 0 ? ref3 : [];
    const activeTicket = tickets[activeTicketIndex];
    var ref4;
    const paymentStatus = (ref4 = modalData === null || modalData === void 0 ? void 0 : modalData.paymentStatus) !== null && ref4 !== void 0 ? ref4 : (modalData === null || modalData === void 0 ? void 0 : modalData.paid) ? "SUCCEEDED" : "PENDING";
    var ref5;
    const paymentProcessor = (ref5 = modalData === null || modalData === void 0 ? void 0 : modalData.paymentProcessor) !== null && ref5 !== void 0 ? ref5 : "Legacy payment";
    var ref6;
    const availableTicketTypes = (ref6 = modalData === null || modalData === void 0 ? void 0 : (ref = modalData.event) === null || ref === void 0 ? void 0 : ref.tickets) !== null && ref6 !== void 0 ? ref6 : [];
    var ref7;
    const ticketTypeSelection = getTicketTypeSelection((ref7 = activeTicket === null || activeTicket === void 0 ? void 0 : activeTicket.title) !== null && ref7 !== void 0 ? ref7 : "", availableTicketTypes);
    const surfaceStyle = (0,react.useMemo)(()=>({
            backgroundColor: theme.backgroundColourSecondary,
            borderColor: theme.borderColour,
            color: theme.textColour
        }), [
        theme
    ]);
    const copyIdentifier = async (type, value)=>{
        if (!value) return;
        try {
            await navigator.clipboard.writeText(value);
            setCopiedIdentifier(type);
            window.setTimeout(()=>setCopiedIdentifier(undefined), 1500);
        } catch (_) {
        // Clipboard access may be blocked by browser permissions.
        }
    };
    const updateActiveTicket = (changes)=>{
        setModalData((current)=>{
            if (!current) return current;
            var _tickets;
            const updatedTickets = [
                ...(_tickets = current.tickets) !== null && _tickets !== void 0 ? _tickets : []
            ];
            if (!updatedTickets[activeTicketIndex]) return current;
            updatedTickets[activeTicketIndex] = {
                ...updatedTickets[activeTicketIndex],
                ...changes
            };
            return {
                ...current,
                tickets: updatedTickets
            };
        });
    };
    const closeModal = ()=>{
        return setShow === null || setShow === void 0 ? void 0 : setShow(false);
    };
    const saveOrder = ()=>{
        if (!modalData) return;
        onComplete(modalData);
        setActiveTicketIndex(0);
        closeModal();
    };
    var ref8, _paymentStatus, _email;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        ...modalProps,
        setShow: setShow,
        className: "!max-w-5xl md:!min-w-0 ".concat(className !== null && className !== void 0 ? className : "", " rounded-md"),
        children: !modalData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "py-12 text-center text-sm opacity-70",
            children: "Select an order to manage it."
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "flex flex-col gap-5 pb-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    "aria-label": "Order summary",
                    className: "rounded-xl border p-4 sm:p-5",
                    style: surfaceStyle,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "min-w-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-xs font-semibold uppercase tracking-wide opacity-60",
                                            children: "Event"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "mt-1 truncate text-xl font-semibold sm:text-2xl",
                                            children: (ref8 = (ref1 = modalData.event) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.event) === null || ref2 === void 0 ? void 0 : ref2.title) !== null && ref8 !== void 0 ? ref8 : "Event unavailable"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "mt-3 flex flex-wrap gap-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold ".concat((_paymentStatus = paymentStatusStyles[paymentStatus]) !== null && _paymentStatus !== void 0 ? _paymentStatus : paymentStatusStyles.PENDING),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlinePayments */.IDG, {
                                                            "aria-hidden": "true",
                                                            className: "h-4 w-4"
                                                        }),
                                                        paymentStatus.replaceAll("_", " ")
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-flex items-center rounded-full border border-slate-300 bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-800",
                                                    children: paymentProcessor
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "inline-flex items-center gap-1.5 rounded-full border border-slate-300 bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-800",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineConfirmationNumber */.cL4, {
                                                            "aria-hidden": "true",
                                                            className: "h-4 w-4"
                                                        }),
                                                        tickets.length,
                                                        " ",
                                                        tickets.length === 1 ? "ticket" : "tickets"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "grid min-w-0 gap-4 sm:grid-cols-2 lg:w-[48%]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Identifier, {
                                            label: "Order ID",
                                            value: modalData.orderId,
                                            copied: copiedIdentifier === "order",
                                            onCopy: ()=>copyIdentifier("order", modalData.orderId)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Identifier, {
                                            label: "Event ID",
                                            value: modalData.eventId,
                                            copied: copiedIdentifier === "event",
                                            onCopy: ()=>copyIdentifier("event", modalData.eventId)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "mt-5 flex flex-col gap-3 border-t pt-4 sm:flex-row sm:items-center sm:justify-between",
                            style: {
                                borderColor: theme.borderColour
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm font-semibold",
                                            children: "Manual paid override"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "mt-0.5 text-xs opacity-70",
                                            children: "Only change this after confirming payment outside Forumm."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    type: "button",
                                    role: "switch",
                                    "aria-checked": !!modalData.paid,
                                    className: "flex cursor-pointer items-center gap-3 self-start rounded-lg px-2 py-1.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forumm-blue sm:self-auto",
                                    onClick: ()=>setModalData((current)=>current ? {
                                                ...current,
                                                paid: !current.paid
                                            } : current),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-sm font-medium",
                                            children: modalData.paid ? "Marked paid" : "Not marked paid"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            "aria-hidden": "true",
                                            className: "relative h-6 w-11 rounded-full transition-colors ".concat(modalData.paid ? "bg-emerald-600" : "bg-slate-400"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "absolute top-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition-transform ".concat(modalData.paid ? "-translate-x-5" : "translate-x-0.5")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                tickets.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    "aria-label": "Ticket holders",
                    className: "grid overflow-hidden rounded-xl border lg:grid-cols-[260px_minmax(0,1fr)]",
                    style: {
                        borderColor: theme.borderColour
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "border-b p-3 lg:border-b-0 lg:border-r",
                            style: surfaceStyle,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "px-2 pb-2 text-xs font-semibold uppercase tracking-wide opacity-60",
                                    children: "Ticket holders"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "flex gap-2 overflow-x-auto pb-1 lg:flex-col lg:overflow-visible",
                                    children: tickets.map((ticket, index)=>{
                                        const isActive = index === activeTicketIndex;
                                        var _ticketCode;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            type: "button",
                                            "aria-current": isActive ? "step" : undefined,
                                            className: "min-w-[210px] cursor-pointer rounded-lg border p-3 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forumm-blue lg:min-w-0 ".concat(isActive ? "border-forumm-blue bg-forumm-blue/10" : "border-transparent hover:bg-black/5"),
                                            onClick: ()=>setActiveTicketIndex(index),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "flex items-center justify-between gap-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                            className: "text-xs font-semibold opacity-60",
                                                            children: [
                                                                "Ticket ",
                                                                index + 1
                                                            ]
                                                        }),
                                                        isActive && /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdCheck */.HhX, {
                                                            "aria-hidden": "true",
                                                            className: "h-4 w-4 text-forumm-blue"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "mt-1 truncate text-sm font-semibold",
                                                    children: ticket.fullName || "Unnamed attendee"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "mt-0.5 truncate text-xs opacity-70",
                                                    children: ticket.isAdditionalGuest ? "Managed by registrar" : ticket.email
                                                })
                                            ]
                                        }, (_ticketCode = ticket.ticketCode) !== null && _ticketCode !== void 0 ? _ticketCode : "".concat(ticket.email, "-").concat(index));
                                    })
                                })
                            ]
                        }),
                        !!activeTicket && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "p-4 sm:p-6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "mb-5 flex items-start justify-between gap-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "text-lg font-semibold",
                                                    children: [
                                                        "Ticket ",
                                                        activeTicketIndex + 1,
                                                        " details"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "mt-1 text-sm opacity-70",
                                                    children: "Update the attendee details or assign another ticket type."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-800",
                                            children: activeTicket.title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "grid gap-4 md:grid-cols-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: "flex flex-col gap-1.5 text-sm font-medium",
                                            children: [
                                                "Full name ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "required"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    required: true,
                                                    type: "text",
                                                    value: activeTicket.fullName,
                                                    placeholder: "John Smith",
                                                    className: "h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 outline-none transition-colors placeholder:text-slate-500 focus:border-forumm-blue focus:ring-2 focus:ring-forumm-blue/20",
                                                    onChange: (event)=>updateActiveTicket({
                                                            fullName: event.target.value
                                                        })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            className: "flex flex-col gap-1.5 text-sm font-medium",
                                            children: [
                                                "Ticket type ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "required"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                                    required: true,
                                                    value: ticketTypeSelection.selectedTitle,
                                                    disabled: availableTicketTypes.length === 0,
                                                    className: "h-11 w-full cursor-pointer rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 outline-none transition-colors focus:border-forumm-blue focus:ring-2 focus:ring-forumm-blue/20 disabled:cursor-not-allowed disabled:bg-slate-100",
                                                    onChange: (event)=>updateActiveTicket({
                                                            title: event.target.value
                                                        }),
                                                    children: ticketTypeSelection.options.map((ticket, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                                            value: ticket.title,
                                                            children: [
                                                                ticket.title,
                                                                ticket.isUnavailable ? " (not currently configured)" : ""
                                                            ]
                                                        }, "".concat(ticket.title, "-").concat(index)))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !activeTicket.isAdditionalGuest && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: "mt-4 flex flex-col gap-1.5 text-sm font-medium",
                                    children: [
                                        "Email address ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "required"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            required: true,
                                            type: "email",
                                            value: (_email = activeTicket.email) !== null && _email !== void 0 ? _email : "",
                                            disabled: activeTicketIndex === 0,
                                            placeholder: "attendee@forumm.to",
                                            className: "h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm text-slate-900 outline-none transition-colors placeholder:text-slate-500 focus:border-forumm-blue focus:ring-2 focus:ring-forumm-blue/20 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-600",
                                            onChange: (event)=>updateActiveTicket({
                                                    email: event.target.value
                                                })
                                        }),
                                        activeTicketIndex === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-xs font-normal opacity-70",
                                            children: "The primary attendee email cannot be changed."
                                        })
                                    ]
                                }),
                                activeTicket.discountCode && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "mt-4 rounded-lg border p-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-xs font-semibold uppercase tracking-wide opacity-60",
                                            children: "Discount code"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "mt-1 font-mono text-sm",
                                            children: activeTicket.discountCode
                                        })
                                    ]
                                }),
                                tickets.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "mt-6 flex items-center justify-between border-t pt-4",
                                    style: {
                                        borderColor: theme.borderColour
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            type: "button",
                                            disabled: activeTicketIndex === 0,
                                            className: "inline-flex cursor-pointer items-center gap-1 rounded-lg px-2 py-1.5 text-sm font-medium transition-colors hover:bg-black/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forumm-blue disabled:cursor-not-allowed disabled:opacity-40",
                                            onClick: ()=>setActiveTicketIndex((index)=>Math.max(0, index - 1)),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdChevronLeft */.G1X, {
                                                    "aria-hidden": "true",
                                                    className: "h-5 w-5"
                                                }),
                                                "Previous"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "text-xs opacity-60",
                                            children: [
                                                activeTicketIndex + 1,
                                                " of ",
                                                tickets.length
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            type: "button",
                                            disabled: activeTicketIndex === tickets.length - 1,
                                            className: "inline-flex cursor-pointer items-center gap-1 rounded-lg px-2 py-1.5 text-sm font-medium transition-colors hover:bg-black/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forumm-blue disabled:cursor-not-allowed disabled:opacity-40",
                                            onClick: ()=>setActiveTicketIndex((index)=>Math.min(tickets.length - 1, index + 1)),
                                            children: [
                                                "Next",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdChevronRight */.FNi, {
                                                    "aria-hidden": "true",
                                                    className: "h-5 w-5"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex flex-col-reverse gap-3 border-t pt-4 sm:flex-row sm:justify-end",
                    style: {
                        borderColor: theme.borderColour
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            title: "Cancel",
                            type: "secondary",
                            size: "medium",
                            className: "w-full sm:w-auto",
                            onClick: closeModal
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            title: "Save order",
                            type: "primary",
                            size: "medium",
                            className: "w-full sm:w-auto",
                            disabled: !modalData,
                            onClick: saveOrder
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var order_manager_OrderModal = (OrderModal);

;// CONCATENATED MODULE: ./components/metrics/TableOrders.tsx













const TableOrders_paymentStatusStyles = {
    SUCCEEDED: "bg-emerald-100 text-emerald-800 border-emerald-200",
    PENDING: "bg-amber-100 text-amber-900 border-amber-200",
    FAILED: "bg-red-100 text-red-800 border-red-200",
    REFUNDED: "bg-slate-200 text-slate-800 border-slate-300",
    CHARGED_BACK: "bg-red-100 text-red-800 border-red-200"
};
const TableOrders_getFiltered = (orders, filter)=>{
    if (!filter || !orders) return orders;
    const lowercasedSearchText = filter.toLowerCase();
    const payload = orders.filter((order)=>{
        var ref, ref1, ref2, ref3, ref4;
        var ref5;
        const orderEmail = (ref5 = order === null || order === void 0 ? void 0 : (ref = order.tickets) === null || ref === void 0 ? void 0 : ref.flatMap((ticket)=>ticket.email ? [
                ticket.email.toLowerCase()
            ] : [])) !== null && ref5 !== void 0 ? ref5 : [];
        var ref6;
        const orderNames = (ref6 = order === null || order === void 0 ? void 0 : (ref1 = order.tickets) === null || ref1 === void 0 ? void 0 : ref1.reduce((acc, t)=>[
                ...acc,
                t.fullName.toLowerCase()
            ], [])) !== null && ref6 !== void 0 ? ref6 : [];
        return orderEmail.find((e)=>e.includes(lowercasedSearchText)) || orderNames.find((n)=>n.includes(lowercasedSearchText)) || (order === null || order === void 0 ? void 0 : order.orderId.includes(lowercasedSearchText)) || (order === null || order === void 0 ? void 0 : (ref2 = order.eventId) === null || ref2 === void 0 ? void 0 : ref2.includes(lowercasedSearchText)) || (order === null || order === void 0 ? void 0 : (ref3 = order.userId) === null || ref3 === void 0 ? void 0 : ref3.includes(lowercasedSearchText)) || ((order === null || order === void 0 ? void 0 : order.paid) ? "paid" : "pending").includes(lowercasedSearchText) || (order === null || order === void 0 ? void 0 : (ref4 = order.quantity) === null || ref4 === void 0 ? void 0 : ref4.toString().includes(lowercasedSearchText));
    });
    return payload;
};
const TableOrders = (param)=>{
    let { orders , className , refetch  } = param;
    const { profile  } = (0,useAuth/* useAuth */.aC)();
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    var ref;
    const org = (ref = profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref !== void 0 ? ref : profile === null || profile === void 0 ? void 0 : profile.university;
    const [filter, setFilter] = (0,react.useState)("");
    const [users, setUsers] = (0,react.useState)([]);
    const [eventsData, setEventsData] = (0,react.useState)([]);
    const orderEvents = orders === null || orders === void 0 ? void 0 : orders.map((o)=>{
        return o === null || o === void 0 ? void 0 : o.eventId;
    }).filter((id)=>typeof id === "string" && id.length === 36).reduce((acc, id)=>{
        if (!id) return acc;
        if (!acc.includes(id)) return [
            ...acc,
            id
        ];
        return acc;
    }, []);
    const orderUsers = orders === null || orders === void 0 ? void 0 : orders.map((o)=>{
        return o === null || o === void 0 ? void 0 : o.userId;
    }).filter((o)=>!!o);
    const { loading: eventsLoading  } = (0,useQuery/* useQuery */.a)(GET_EVENTS_BY_IDS, {
        variables: {
            eventIds: orderEvents
        },
        skip: orderEvents.length < 1,
        onCompleted: (data)=>{
            setEventsData(data.getEventsByIds);
        }
    });
    const { loading: usersLoading  } = (0,useQuery/* useQuery */.a)(GetUsersByIds/* GET_USERS_BY_IDS */.B, {
        variables: {
            input: {
                userIds: orderUsers
            }
        },
        skip: orderUsers.length < 1,
        onCompleted: (data)=>{
            setUsers(data.getUsersByIds.items);
        }
    });
    const filteredData = (0,react.useMemo)(()=>{
        return TableOrders_getFiltered(orders, filter).map((o)=>{
            const user = users.find((u)=>{
                return u.userId === (o === null || o === void 0 ? void 0 : o.userId);
            });
            const event = eventsData.find((e)=>{
                return e.eventId === (o === null || o === void 0 ? void 0 : o.eventId);
            });
            const payload = {
                ...o,
                user,
                event
            };
            return payload;
        });
    }, [
        orders,
        filter,
        users,
        eventsData
    ]);
    const [isOrderModalOpen, setOrderModalOpen] = (0,react.useState)(false);
    const [orderModalData, setOrderModalData] = (0,react.useState)();
    const [updateOrder] = (0,useMutation/* useMutation */.D)(UPDATE_ORDER);
    const handleSubmit = (data)=>{
        if (data.orderId) {
            var ref;
            const ticketPayload = (ref = data.tickets) === null || ref === void 0 ? void 0 : ref.map((t)=>({
                    email: t.email,
                    fullName: t.fullName,
                    title: t.title,
                    registrationVisible: t.registrationVisible
                }));
            updateOrder({
                variables: {
                    input: {
                        orderId: data.orderId,
                        paid: data.paid,
                        ticketsPurchased: ticketPayload
                    }
                }
            }).then(()=>refetch());
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(order_manager_OrderModal, {
                show: isOrderModalOpen,
                setShow: setOrderModalOpen,
                className: "!max-w-5xl md:!min-w-0",
                title: "Order Manager",
                data: orderModalData,
                onComplete: (data)=>handleSubmit(data)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "w-full flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    color: "foregroundColour",
                    className: "w-full max-w-[1500px] rounded-3xl border border-forumm-menu-border p-3 shadow-md sm:p-5 ".concat(className),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "mb-6 flex flex-col gap-4 md:flex-row md:items-end md:justify-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            className: "text-xl font-semibold md:text-2xl",
                                            children: "".concat(org, "'s orders")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "mt-1 text-sm opacity-70",
                                            children: [
                                                filteredData.length,
                                                " of ",
                                                orders.length,
                                                " ",
                                                orders.length === 1 ? "order" : "orders"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: "relative block w-full md:max-w-md",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Search orders"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineSearch */.Zh8, {
                                            "aria-hidden": "true",
                                            className: "pointer-events-none absolute left-3 top-1/2 z-10 h-5 w-5 -translate-y-1/2 text-slate-500"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "search",
                                            value: filter,
                                            className: "h-11 w-full rounded-lg border border-slate-300 bg-white py-2 pl-10 pr-3 text-sm text-slate-900 outline-none transition-colors placeholder:text-slate-500 focus:border-forumm-blue focus:ring-2 focus:ring-forumm-blue/20",
                                            placeholder: "Search attendee, event, email or order ID",
                                            onChange: (event)=>setFilter(event.target.value)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "max-h-[560px] overflow-y-auto rounded-xl border",
                            style: {
                                borderColor: theme.borderColour
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "sticky top-0 z-10 hidden grid-cols-[minmax(220px,1.4fr)_minmax(180px,1fr)_minmax(180px,0.9fr)_100px_36px] items-center gap-4 border-b px-4 py-3 text-xs font-semibold uppercase tracking-wide md:grid",
                                    style: {
                                        backgroundColor: theme.backgroundColourSecondary,
                                        borderColor: theme.borderColour
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            children: "Event and order"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            children: "Primary attendee"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            children: "Payment"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-center",
                                            children: "Tickets"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Open"
                                        })
                                    ]
                                }),
                                filteredData.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "flex flex-col items-center justify-center px-6 py-16 text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineSearch */.Zh8, {
                                            "aria-hidden": "true",
                                            className: "h-8 w-8 opacity-40"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "mt-3 font-semibold",
                                            children: "No matching orders"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "mt-1 text-sm opacity-70",
                                            children: "Try a different attendee, event, email, or order ID."
                                        })
                                    ]
                                }) : filteredData.map((orderData)=>{
                                    var ref, ref1, ref2, ref3;
                                    var _paymentStatus;
                                    const status = (_paymentStatus = orderData.paymentStatus) !== null && _paymentStatus !== void 0 ? _paymentStatus : orderData.paid ? "SUCCEEDED" : "PENDING";
                                    var _paymentProcessor;
                                    const processor = (_paymentProcessor = orderData.paymentProcessor) !== null && _paymentProcessor !== void 0 ? _paymentProcessor : "LEGACY";
                                    var ref4;
                                    const eventTitle = (ref4 = (ref = orderData.event) === null || ref === void 0 ? void 0 : (ref1 = ref.event) === null || ref1 === void 0 ? void 0 : ref1.title) !== null && ref4 !== void 0 ? ref4 : "Event unavailable";
                                    const attendee = (ref2 = orderData.tickets) === null || ref2 === void 0 ? void 0 : ref2[0];
                                    var ref5, ref6, _status, _quantity, ref7;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        type: "button",
                                        "aria-label": "Manage order for ".concat(eventTitle),
                                        className: "grid w-full cursor-pointer grid-cols-[minmax(0,1fr)_auto] gap-3 border-b p-4 text-left transition-colors last:border-b-0 hover:bg-black/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-forumm-blue md:grid-cols-[minmax(220px,1.4fr)_minmax(180px,1fr)_minmax(180px,0.9fr)_100px_36px] md:items-center md:gap-4",
                                        style: {
                                            borderColor: theme.borderColour,
                                            color: theme.textColour
                                        },
                                        onClick: ()=>{
                                            setOrderModalOpen(true);
                                            setOrderModalData(orderData);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                className: "min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "truncate text-sm font-semibold sm:text-base",
                                                        children: eventsLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                                                            size: "small"
                                                        }) : eventTitle
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "mt-1 truncate font-mono text-xs opacity-60",
                                                        children: orderData.orderId
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdChevronRight */.FNi, {
                                                "aria-hidden": "true",
                                                className: "h-5 w-5 self-center opacity-50 md:order-last"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                className: "col-span-2 min-w-0 md:col-span-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "truncate text-sm font-medium",
                                                        children: (ref5 = attendee === null || attendee === void 0 ? void 0 : attendee.fullName) !== null && ref5 !== void 0 ? ref5 : "Unnamed attendee"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "mt-0.5 truncate text-xs opacity-60",
                                                        children: (ref6 = attendee === null || attendee === void 0 ? void 0 : attendee.email) !== null && ref6 !== void 0 ? ref6 : "No email"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                className: "col-span-2 flex flex-wrap items-center gap-2 md:col-span-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "inline-flex rounded-full border px-2.5 py-1 text-xs font-semibold ".concat((_status = TableOrders_paymentStatusStyles[status]) !== null && _status !== void 0 ? _status : TableOrders_paymentStatusStyles.PENDING),
                                                        children: status.replaceAll("_", " ")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-xs font-semibold opacity-60",
                                                        children: processor
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                className: "col-span-2 flex items-center gap-1.5 text-sm font-medium md:col-span-1 md:justify-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineConfirmationNumber */.cL4, {
                                                        "aria-hidden": "true",
                                                        className: "h-4 w-4 opacity-60"
                                                    }),
                                                    (ref7 = (_quantity = orderData.quantity) !== null && _quantity !== void 0 ? _quantity : (ref3 = orderData.tickets) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref7 !== void 0 ? ref7 : 1
                                                ]
                                            })
                                        ]
                                    }, orderData.orderId);
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var metrics_TableOrders = (TableOrders);

// EXTERNAL MODULE: ./components/inputs/DropdownInput.tsx
var DropdownInput = __webpack_require__(61993);
// EXTERNAL MODULE: ./graphql/__generated/graphql.ts
var graphql = __webpack_require__(68240);
// EXTERNAL MODULE: ./graphql/users/manageOrganisationOrganisers.ts
var manageOrganisationOrganisers = __webpack_require__(77223);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
;// CONCATENATED MODULE: ./components/metrics/TableOrganisers.tsx














const systemEmailMarkers = [
    "forumm.to",
    "pauljohnpirie",
    "448.studio"
];
const isSystemEmail = (email)=>{
    var ref;
    const lowerEmail = (ref = email === null || email === void 0 ? void 0 : email.toLowerCase()) !== null && ref !== void 0 ? ref : "";
    return systemEmailMarkers.some((marker)=>lowerEmail.includes(marker));
};
var ref;
const hasGlobalOrganisationAccess = (permissions)=>{
    return (ref = permissions === null || permissions === void 0 ? void 0 : permissions.some((permission)=>{
        const [type, action, resource] = permission.split("::");
        return type === "USER" && (action === "ACCESS_ORGANISATION" || action === "MANAGE_ORGANISATION") && resource === "*";
    })) !== null && ref !== void 0 ? ref : false;
};
const TableOrganisers_getFiltered = (users, filter, showSystemEmails)=>{
    const visibleUsers = (users || []).filter((user)=>!!user && (showSystemEmails || !isSystemEmail(user.email)));
    if (!filter) return visibleUsers;
    const lowercasedSearchText = filter.toLowerCase();
    return visibleUsers.filter((user)=>{
        var ref, ref1;
        return (user === null || user === void 0 ? void 0 : (ref = user.name) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(lowercasedSearchText)) || (user === null || user === void 0 ? void 0 : (ref1 = user.email) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase().includes(lowercasedSearchText));
    });
};
const getRoleLabel = (role)=>role === graphql/* OrganisationOrganiserRole.SpaceAdmin */.x1.SpaceAdmin ? "Space Admin" : "Organiser";
const getRoleFromPermissions = (permissions, organisationName)=>{
    const isSpaceAdmin = permissions === null || permissions === void 0 ? void 0 : permissions.some((permission)=>{
        const [type, action, resource] = permission.split("::");
        return type === "USER" && action === "MANAGE_ORGANISATION" && (resource === "*" || (resource === null || resource === void 0 ? void 0 : resource.toUpperCase()) === organisationName.toUpperCase());
    });
    return isSpaceAdmin ? graphql/* OrganisationOrganiserRole.SpaceAdmin */.x1.SpaceAdmin : graphql/* OrganisationOrganiserRole.Organiser */.x1.Organiser;
};
const getInviteName = (name)=>{
    const parts = name.trim().split(" ").filter(Boolean);
    var ref;
    return {
        firstName: (ref = parts[0]) !== null && ref !== void 0 ? ref : "",
        lastName: parts.slice(1).join(" ")
    };
};
const TableOrganisers = (param)=>{
    let { users , pendingInvites =[] , className , organisationName , refetch  } = param;
    const { profile , hasPermission , isAdmin  } = (0,useAuth/* useAuth */.aC)();
    const { theme  } = (0,useTheme/* useTheme */.Fg)();
    const isDarkTheme = theme.type === "DARK";
    const org = organisationName || (profile === null || profile === void 0 ? void 0 : profile.company) || (profile === null || profile === void 0 ? void 0 : profile.university) || "";
    const canManageOrganisers = isAdmin || hasPermission("USER::MANAGE_ORGANISATION::".concat(org));
    const [filter, setFilter] = (0,react.useState)("");
    const [inviteModalOpen, setInviteModalOpen] = (0,react.useState)(false);
    const [inviteEmail, setInviteEmail] = (0,react.useState)("");
    const [inviteName, setInviteName] = (0,react.useState)("");
    const [inviteRole, setInviteRole] = (0,react.useState)(graphql/* OrganisationOrganiserRole.Organiser */.x1.Organiser);
    const [formError, setFormError] = (0,react.useState)();
    const [statusMessage, setStatusMessage] = (0,react.useState)();
    const [statusType, setStatusType] = (0,react.useState)("success");
    const [actionKey, setActionKey] = (0,react.useState)();
    const [refreshLoading, setRefreshLoading] = (0,react.useState)(false);
    const [inviteOrganiser, { loading: inviteLoading  }] = (0,useMutation/* useMutation */.D)(manageOrganisationOrganisers/* INVITE_ORGANISATION_ORGANISER */.x3);
    const [removeOrganiser] = (0,useMutation/* useMutation */.D)(manageOrganisationOrganisers/* REMOVE_ORGANISATION_ORGANISER */.gE);
    const [updateOrganiserRole] = (0,useMutation/* useMutation */.D)(manageOrganisationOrganisers/* UPDATE_ORGANISATION_ORGANISER_ROLE */.bV);
    const [cancelInvite] = (0,useMutation/* useMutation */.D)(manageOrganisationOrganisers/* CANCEL_ORGANISATION_ORGANISER_INVITE */.nf);
    const filteredData = (0,react.useMemo)(()=>{
        var ref;
        var _permissions, _role;
        const organiserRows = users.map((user)=>({
                ...user,
                pending: false,
                role: (_role = user.role) !== null && _role !== void 0 ? _role : getRoleFromPermissions((_permissions = user.permissions) !== null && _permissions !== void 0 ? _permissions : undefined, organisationName)
            }));
        const pendingRows = pendingInvites.map((invite)=>({
                ...invite,
                pending: true
            }));
        var ref1, ref2, ref3, ref4;
        return (ref = TableOrganisers_getFiltered([
            ...organiserRows,
            ...pendingRows
        ], filter, !!isAdmin)) === null || ref === void 0 ? void 0 : ref.sort((a, b)=>{
            return ((ref2 = (ref1 = a === null || a === void 0 ? void 0 : a.name) !== null && ref1 !== void 0 ? ref1 : a === null || a === void 0 ? void 0 : a.email) !== null && ref2 !== void 0 ? ref2 : "").localeCompare((ref4 = (ref3 = b === null || b === void 0 ? void 0 : b.name) !== null && ref3 !== void 0 ? ref3 : b === null || b === void 0 ? void 0 : b.email) !== null && ref4 !== void 0 ? ref4 : "");
        });
    }, [
        users,
        pendingInvites,
        filter,
        organisationName,
        isAdmin
    ]);
    const resetInviteForm = ()=>{
        setInviteEmail("");
        setInviteName("");
        setInviteRole(graphql/* OrganisationOrganiserRole.Organiser */.x1.Organiser);
        setFormError(undefined);
    };
    const setStatus = function(message) {
        let type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "success";
        setStatusMessage(message);
        setStatusType(type);
    };
    const handleInviteSubmit = async ()=>{
        setFormError(undefined);
        setStatusMessage(undefined);
        const email = inviteEmail.trim().toLowerCase();
        const name = inviteName.trim();
        if (!email) {
            setFormError("Email address is required");
            return;
        }
        if (!/^\S+@\S+\.\S+$/.test(email)) {
            setFormError("Enter a valid email address");
            return;
        }
        try {
            await inviteOrganiser({
                variables: {
                    input: {
                        organisationName,
                        email,
                        name,
                        role: inviteRole,
                        ...getInviteName(name)
                    }
                }
            });
            await refetch();
            resetInviteForm();
            setInviteModalOpen(false);
            setStatus("Organiser invite sent");
        } catch (error) {
            setFormError("Unable to invite organiser");
        }
        setInviteModalOpen(false);
    };
    const handleRemoveOrganiser = async (row)=>{
        if (!row.userId) return;
        setActionKey("remove-".concat(row.userId));
        setStatusMessage(undefined);
        try {
            await removeOrganiser({
                variables: {
                    input: {
                        organisationName,
                        userId: row.userId
                    }
                }
            });
            await refetch();
            setStatus("Organiser removed");
        } catch (error) {
            setStatus("Unable to remove organiser", "error");
        } finally{
            setActionKey(undefined);
        }
    };
    const handleUpdateRole = async (row, role)=>{
        if (!row.userId) return;
        setActionKey("role-".concat(row.userId));
        setStatusMessage(undefined);
        try {
            await updateOrganiserRole({
                variables: {
                    input: {
                        organisationName,
                        userId: row.userId,
                        role
                    }
                }
            });
            await refetch();
            setStatus(role === graphql/* OrganisationOrganiserRole.SpaceAdmin */.x1.SpaceAdmin ? "Organiser upgraded to Space Admin" : "Space Admin changed to Organiser");
        } catch (error) {
            setStatus("Unable to update organiser role", "error");
        } finally{
            setActionKey(undefined);
        }
    };
    const handleCancelInvite = async (invite)=>{
        if (!invite.inviteId) return;
        setActionKey("invite-".concat(invite.inviteId));
        setStatusMessage(undefined);
        try {
            await cancelInvite({
                variables: {
                    inviteId: invite.inviteId
                }
            });
            await refetch();
            setStatus("Invite cancelled");
        } catch (error) {
            setStatus("Unable to cancel invite", "error");
        } finally{
            setActionKey(undefined);
        }
    };
    const handleRefresh = async ()=>{
        setRefreshLoading(true);
        setStatusMessage(undefined);
        try {
            await refetch();
            setStatus("Organiser list refreshed");
        } catch (error) {
            setStatus("Unable to refresh organisers", "error");
        } finally{
            setRefreshLoading(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                title: "Invite organiser",
                show: inviteModalOpen,
                setShow: (show)=>{
                    setInviteModalOpen(show);
                    if (!show) resetInviteForm();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                            label: "Name",
                            value: inviteName,
                            placeholder: "Jane Smith",
                            onChange: setInviteName,
                            className: "w-full"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                            label: "Email",
                            value: inviteEmail,
                            placeholder: "jane@example.com",
                            onChange: setInviteEmail,
                            className: "w-full",
                            type: "email"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownInput/* DropdownInput */.f, {
                            label: "Role",
                            value: inviteRole,
                            onChange: (value)=>setInviteRole(value),
                            options: [
                                {
                                    label: "Organiser",
                                    value: graphql/* OrganisationOrganiserRole.Organiser */.x1.Organiser
                                },
                                {
                                    label: "Space Admin",
                                    value: graphql/* OrganisationOrganiserRole.SpaceAdmin */.x1.SpaceAdmin
                                }
                            ],
                            className: "w-full"
                        }),
                        formError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "rounded-xl border border-red-300 bg-red-50 px-4 py-3 text-center text-sm font-semibold text-red-700",
                            children: formError
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            className: "flex w-full flex-col gap-3 sm:flex-row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    title: "Cancel",
                                    type: "secondary",
                                    className: "flex-1",
                                    onClick: ()=>{
                                        setInviteModalOpen(false);
                                        resetInviteForm();
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    title: "Send invite",
                                    className: "flex-1",
                                    loading: inviteLoading,
                                    disabled: inviteLoading,
                                    onClick: handleInviteSubmit
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "w-full flex justify-center items-center flex-col max-w-[1500px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "w-full flex flex-col justify-end gap-3 mb-4 pr-5 sm:flex-row sm:items-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                title: "Refresh",
                                type: "secondary",
                                size: "auto",
                                className: "w-full md:w-auto",
                                loading: refreshLoading,
                                disabled: refreshLoading,
                                onClick: handleRefresh
                            }),
                            canManageOrganisers && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                title: "Invite organiser",
                                size: "auto",
                                className: "w-full md:w-auto",
                                onClick: ()=>setInviteModalOpen(true)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        color: "foregroundColour",
                        className: "w-full flex-2 rounded-3xl border shadow-md border-forumm-menu-border p-3 sm:p-5 max-w-[1500px] justify-center items-center ".concat(className),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "flex flex-col gap-4 md:flex-row w-full justify-between items-center mb-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        className: "text-xl text-center md:text-left",
                                        children: "".concat(org, "'s Organiser Account").concat((users === null || users === void 0 ? void 0 : users.length) > 1 ? "s" : "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "flex w-full flex-col gap-3 md:w-auto md:flex-row md:items-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "md:min-w-[300px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                                value: filter,
                                                className: "w-full",
                                                placeholder: "Enter your search terms",
                                                onChange: setFilter
                                            })
                                        })
                                    })
                                ]
                            }),
                            statusMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "mb-4 rounded-xl border px-4 py-3 text-center text-sm font-semibold ".concat(statusType === "success" ? "border-green-300 bg-green-50 text-green-700" : "border-red-300 bg-red-50 text-red-700"),
                                children: statusMessage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "max-h-[360px] overflow-x-auto overflow-y-scroll scrollbar-hide",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "w-full min-w-[920px] flex flex-row ".concat(isDarkTheme ? "bg-dark" : "bg-forumm-light-gray", " rounded-t-xl py-2 mb-5"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "flex-1 font-bold text-start text-sm sm:text-base ml-4",
                                                children: "Organiser"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "flex-1 font-bold text-sm md:text-base",
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "flex-1 font-bold text-sm md:text-base",
                                                children: "Position"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "flex-1 font-bold text-sm md:text-base",
                                                children: "Organisation"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "w-[130px] font-bold text-sm md:text-base",
                                                children: "Status"
                                            }),
                                            canManageOrganisers && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "w-[260px] font-bold text-sm md:text-base",
                                                children: "Actions"
                                            })
                                        ]
                                    }),
                                    (filteredData || []).map((row)=>{
                                        const isPending = row.pending === true;
                                        const pendingRow = row;
                                        const organiserRow = row;
                                        var _permissions, _role;
                                        const role = isPending ? pendingRow.role : (_role = organiserRow.role) !== null && _role !== void 0 ? _role : getRoleFromPermissions((_permissions = organiserRow.permissions) !== null && _permissions !== void 0 ? _permissions : undefined, organisationName);
                                        const isCurrentUser = !isPending && organiserRow.userId === (profile === null || profile === void 0 ? void 0 : profile.userId);
                                        const rowKey = isPending ? pendingRow.inviteId : organiserRow.email || organiserRow.userId || (0,v4/* default */.Z)();
                                        const showSystemEmailHint = !!isAdmin && isSystemEmail(row.email);
                                        const hasGlobalAccess = !isPending && hasGlobalOrganisationAccess(organiserRow.permissions);
                                        var _company;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "flex min-w-[920px] flex-row items-center mb-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "flex-1 flex flex-row text-start justify-start text-sm md:text-base ml-4 break-all p-2",
                                                    children: [
                                                        !isPending && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                            className: "w-[30px] h-[30px] shrink-0 rounded-full translate-y-[-4px] mr-2 bg-cover",
                                                            style: {
                                                                backgroundImage: "url(".concat(organiserRow.profileImage ? organiserRow.profileImage : "https://assets.tumblr.com/images/default_header/optica_pattern_11.png", ")")
                                                            }
                                                        }),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                            className: "flex min-w-0 flex-col gap-1",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                    children: row.name || (isPending ? "Pending organiser" : "")
                                                                }),
                                                                showSystemEmailHint && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                    className: "text-xs font-semibold text-forumm-orange",
                                                                    children: "Only you can see this"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "flex-1 text-sm md:text-base break-all p-2",
                                                    children: row.email
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "flex-1 text-ellipsis text-sm md:text-base break-all p-2",
                                                    children: isPending ? "-" : organiserRow.jobTitle
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "flex-1 text-sm md:text-base",
                                                    children: isPending ? org : (_company = organiserRow.company) !== null && _company !== void 0 ? _company : organiserRow.university
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "w-[130px] text-sm md:text-base",
                                                    children: isPending ? "Pending invite" : getRoleLabel(role)
                                                }),
                                                canManageOrganisers && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "flex w-[260px] flex-row flex-wrap gap-2 text-sm md:text-base",
                                                    children: isPending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                        title: "Cancel",
                                                        type: "danger",
                                                        size: "small",
                                                        loading: actionKey === "invite-".concat(pendingRow.inviteId),
                                                        disabled: actionKey === "invite-".concat(pendingRow.inviteId),
                                                        onClick: ()=>handleCancelInvite(pendingRow)
                                                    }) : hasGlobalAccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "text-xs font-semibold text-forumm-orange",
                                                        children: "Global access"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            role === graphql/* OrganisationOrganiserRole.SpaceAdmin */.x1.SpaceAdmin ? !isCurrentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                title: "Downgrade",
                                                                type: "secondary",
                                                                size: "small",
                                                                loading: actionKey === "role-".concat(organiserRow.userId),
                                                                disabled: actionKey === "role-".concat(organiserRow.userId),
                                                                onClick: ()=>handleUpdateRole(organiserRow, graphql/* OrganisationOrganiserRole.Organiser */.x1.Organiser)
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                title: "Make admin",
                                                                type: "secondary",
                                                                size: "small",
                                                                loading: actionKey === "role-".concat(organiserRow.userId),
                                                                disabled: actionKey === "role-".concat(organiserRow.userId),
                                                                onClick: ()=>handleUpdateRole(organiserRow, graphql/* OrganisationOrganiserRole.SpaceAdmin */.x1.SpaceAdmin)
                                                            }),
                                                            !isCurrentUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                title: "Remove",
                                                                type: "danger",
                                                                size: "small",
                                                                loading: actionKey === "remove-".concat(organiserRow.userId),
                                                                disabled: actionKey === "remove-".concat(organiserRow.userId),
                                                                confirmationModal: {
                                                                    title: "Remove organiser",
                                                                    content: "This will remove organiser access for this organisation."
                                                                },
                                                                onClick: ()=>handleRemoveOrganiser(organiserRow)
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, rowKey);
                                    }),
                                    (filteredData || []).length < 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "py-8 text-center text-sm",
                                        children: "No organisers found."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var metrics_TableOrganisers = (TableOrganisers);

;// CONCATENATED MODULE: ./graphql/events/GetMembershipsByCompany.ts

const GET_ACTIVE_MEMBERSHIPS_BY_COMPANY = (0,_generated/* graphql */.B)("\n  query GetActiveMembershipsByCompany($organisationName: String!) {\n    getActiveMembershipsByCompany(name: $organisationName) {\n      orderId\n      orgName\n      userId\n      paid\n      customerEmail\n      timestamp\n      lastUpdated\n      priceId\n    }\n  }\n");

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
;// CONCATENATED MODULE: ./graphql/events/GetOrdersByCompany.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getOrdersByOrganisation($organisationName: String!) {\n    getOrdersByOrganisation(organisationName: $organisationName) {\n      orderId\n      userId\n      eventId\n      quantity\n      paid\n      paymentProcessor\n      paymentStatus\n      paymentLastUpdated\n      tickets {\n        title\n        email\n        fullName\n        discountCode\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const GET_ORDERS_BY_ORGANISATION = (0,lib/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./graphql/users/getFullOrganiserByCompany.ts

const GET_FULL_ORGANISERS_BY_COMPANY = (0,_generated/* graphql */.B)("\n  query GetFullOrganiserByCompany($company: String!) {\n    getOrganiserByCompany(company: $company) {\n      items {\n        ...UserFull\n      }\n      total\n      nextToken\n    }\n  }\n");

// EXTERNAL MODULE: ./libs/Utility/util.ts + 2 modules
var util = __webpack_require__(52229);
;// CONCATENATED MODULE: ./components/order-manager/index.tsx














const OrderManager = ()=>{
    const { profile , isOrganizer  } = (0,useAuth/* useAuth */.aC)();
    var ref;
    const { data , loading , error , refetch  } = (0,useQuery/* useQuery */.a)(GET_ORDERS_BY_ORGANISATION, {
        variables: {
            organisationName: (ref = profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref !== void 0 ? ref : ""
        },
        skip: !(profile === null || profile === void 0 ? void 0 : profile.company) || !isOrganizer
    });
    if (!(data === null || data === void 0 ? void 0 : data.getOrdersByOrganisation) && loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
        className: "mt-1 mx-auto",
        size: "medium"
    });
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
        className: "flex flex-col items-center mt-14 text-white w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(metrics_TableOrders, {
            orders: (ref1 = data === null || data === void 0 ? void 0 : data.getOrdersByOrganisation) !== null && ref1 !== void 0 ? ref1 : [],
            refetch: refetch
        })
    });
};
const OrganiserManager = (param)=>{
    let { className  } = param;
    var ref, ref1;
    const { profile , hasPermission , isAdmin  } = (0,useAuth/* useAuth */.aC)();
    var ref2, ref3;
    const organisationName = (ref3 = (ref2 = profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref2 !== void 0 ? ref2 : profile === null || profile === void 0 ? void 0 : profile.university) !== null && ref3 !== void 0 ? ref3 : "";
    const canManageOrganisers = isAdmin || hasPermission("USER::MANAGE_ORGANISATION::".concat(organisationName));
    const shouldUseOrganisationOrganisersQuery = !!organisationName && canManageOrganisers;
    const shouldUseCompanyOrganisersQuery = !!organisationName && !shouldUseOrganisationOrganisersQuery;
    const { data , loading , refetch  } = (0,useQuery/* useQuery */.a)(GET_FULL_ORGANISERS_BY_COMPANY, {
        variables: {
            company: organisationName
        },
        skip: !shouldUseCompanyOrganisersQuery
    });
    const { data: organisationOrganiserData , loading: organisationOrganiserLoading , refetch: refetchOrganisationOrganisers  } = (0,useQuery/* useQuery */.a)(manageOrganisationOrganisers/* GET_ORGANISATION_ORGANISERS */.V$, {
        variables: {
            organisationName
        },
        skip: !shouldUseOrganisationOrganisersQuery,
        errorPolicy: "all"
    });
    var ref4;
    const organisers = (ref4 = organisationOrganiserData === null || organisationOrganiserData === void 0 ? void 0 : (ref = organisationOrganiserData.getOrganisationOrganisers) === null || ref === void 0 ? void 0 : ref.organisers) !== null && ref4 !== void 0 ? ref4 : data === null || data === void 0 ? void 0 : data.getOrganiserByCompany.items;
    const refetchOrganisers = async ()=>{
        if (shouldUseOrganisationOrganisersQuery) {
            await refetchOrganisationOrganisers();
            return;
        }
        await refetch();
    };
    if (shouldUseCompanyOrganisersQuery && !(data === null || data === void 0 ? void 0 : data.getOrganiserByCompany) && loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
        className: "mt-1 mx-auto",
        size: "medium"
    });
    if (shouldUseOrganisationOrganisersQuery && !organisers && organisationOrganiserLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
        className: "mt-1 mx-auto",
        size: "medium"
    });
    var ref5, ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
        className: "flex flex-col items-center mt-14 text-white w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(metrics_TableOrganisers, {
            users: (ref5 = (0,util/* cleanGqlPayload */.GR)(organisers)) !== null && ref5 !== void 0 ? ref5 : [],
            pendingInvites: (ref6 = (0,util/* cleanGqlPayload */.GR)(organisationOrganiserData === null || organisationOrganiserData === void 0 ? void 0 : (ref1 = organisationOrganiserData.getOrganisationOrganisers) === null || ref1 === void 0 ? void 0 : ref1.pendingInvites)) !== null && ref6 !== void 0 ? ref6 : [],
            className: className,
            organisationName: organisationName,
            refetch: refetchOrganisers
        })
    });
};
const MemberManager = ()=>{
    const { profile , isOrganizer  } = (0,useAuth/* useAuth */.aC)();
    var ref;
    const { data , loading , error , refetch  } = (0,useQuery/* useQuery */.a)(GET_ACTIVE_MEMBERSHIPS_BY_COMPANY, {
        variables: {
            organisationName: (ref = profile === null || profile === void 0 ? void 0 : profile.company) !== null && ref !== void 0 ? ref : ""
        },
        skip: !(profile === null || profile === void 0 ? void 0 : profile.company) || !isOrganizer
    });
    if (!(data === null || data === void 0 ? void 0 : data.getActiveMembershipsByCompany) && loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
        className: "mt-1 mx-auto",
        size: "medium"
    });
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
        className: "flex flex-col items-center mt-14 text-white w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(metrics_TableMembers, {
            orders: (ref1 = data === null || data === void 0 ? void 0 : data.getActiveMembershipsByCompany) !== null && ref1 !== void 0 ? ref1 : [],
            refetch: refetch
        })
    });
};

// EXTERNAL MODULE: ./graphql/organisation/getMembershipOptionsForOrganisation.ts
var getMembershipOptionsForOrganisation = __webpack_require__(4893);
;// CONCATENATED MODULE: ./graphql/organisation/createMebership.ts

const CREATE_MEMBERSHIP = (0,_generated/* graphql */.B)("\n  mutation CreateMembership($data: CreateMembershipInput!) {\n    createMembership(data: $data) {\n      __typename\n\n      ... on CreateMembershipOutput {\n        productId\n        prices {\n          priceAmount\n          priceId\n          interval\n          currency\n          priceId\n          title\n        }\n        name\n      }\n\n      ... on APIError {\n        error\n        code\n      }\n    }\n  }\n");

// EXTERNAL MODULE: ./components/email-builder/index.tsx
var email_builder = __webpack_require__(79656);
// EXTERNAL MODULE: ./components/inputs/RichTextEditor/RichTextEditor.tsx
var RichTextEditor = __webpack_require__(19460);
// EXTERNAL MODULE: ./components/event/Accordion.tsx
var Accordion = __webpack_require__(47906);
// EXTERNAL MODULE: ./components/base/Table.tsx
var Table = __webpack_require__(45672);
// EXTERNAL MODULE: ./components/event/TableRowActions.tsx
var TableRowActions = __webpack_require__(29033);
;// CONCATENATED MODULE: ./graphql/organisation/updateMebership.ts

const UPDATE_MEMBERSHIP = (0,_generated/* graphql */.B)("\n  mutation UpdateMembership($data: UpdateMembershipInput!) {\n    updateMembership(data: $data) {\n      __typename\n\n      ... on MutationOutput {\n        success\n      }\n\n      ... on APIError {\n        error\n        code\n      }\n    }\n  }\n");

// EXTERNAL MODULE: ./components/inputs/PriceInput.tsx
var PriceInput = __webpack_require__(84456);
// EXTERNAL MODULE: ./libs/currencies.ts
var currencies = __webpack_require__(30530);
// EXTERNAL MODULE: ./libs/useOrganisationProfile.ts
var useOrganisationProfile = __webpack_require__(19058);
// EXTERNAL MODULE: ./components/inputs/RichTextEditor/TextEditorUtil.tsx
var TextEditorUtil = __webpack_require__(99212);
// EXTERNAL MODULE: ./components/email-builder/emailPreview.tsx + 1 modules
var emailPreview = __webpack_require__(51062);
;// CONCATENATED MODULE: ./graphql/membership/triggerMembershipMail.ts

const TRIGGER_MEMBERSHIP_EMAIL = (0,_generated/* graphql */.B)("\n  mutation triggerMembershipEmail($orgName: String!, $template: String!) {\n    triggerMembershipEmail(orgName: $orgName, emailTemplate: $template)\n  }\n");

// EXTERNAL MODULE: ./components/inputs/CheckboxInput.tsx
var CheckboxInput = __webpack_require__(98805);
;// CONCATENATED MODULE: ./libs/Router/OrganisationContext.ts

const OrganisationContext = (0,react.createContext)({
    setHasUnsavedChanges: ()=>{},
    hasUnsavedChanges: false
});
const InitialiseOrganisationContext = ()=>{
    const [hasUnsavedChanges, setHasUnsavedChanges] = (0,react.useState)(false);
    return {
        hasUnsavedChanges,
        setHasUnsavedChanges
    };
};
const useOrganisationContext = ()=>{
    const ctx = (0,react.useContext)(OrganisationContext);
    return {
        ...ctx
    };
};

;// CONCATENATED MODULE: ./components/organisation/MembershipSettings/MembershipSettings.tsx


































const INITIAL_MEMBERSHIP_DATA = {
    title: "Premium Membership",
    shortDescription: "A brief description of what your membership offers.",
    // description: undefined,
    thumbnailImage: "",
    bannerImage: "",
    emailTemplates: []
};
const MembershipSettings = ()=>{
    var ref, ref1, ref2, ref3, ref4, ref5;
    const uploadFile = (0,useFileUploader/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const saveEnabled = (0,react.useRef)(false);
    const { profile , isOrganizer , isAdmin  } = (0,useAuth/* useAuth */.aC)();
    const { profile: orgProfile  } = (0,useOrganisationProfile/* useOrganisationProfile */.k)(profile === null || profile === void 0 ? void 0 : profile.company);
    const [errors, setErrors] = (0,react.useState)([]);
    const [hasUnsavedProductChanges, setHasUnsavedProductChanges] = (0,react.useState)(false);
    const [showPriceModal, setShowPriceModal] = (0,react.useState)(false);
    const [priceModalData, setPriceModalData] = (0,react.useState)();
    const [productData, setProductData] = (0,react.useState)();
    const [showEmailModal, setShowEmailModal] = (0,react.useState)(false);
    const [emailModalData, setEmailModalData] = (0,react.useState)({});
    const [descriptionData, setDescriptionData] = (0,react.useState)(undefined);
    const [createMembership] = (0,useMutation/* useMutation */.D)(CREATE_MEMBERSHIP);
    const [updateMembership] = (0,useMutation/* useMutation */.D)(UPDATE_MEMBERSHIP);
    const [triggerMail] = (0,useMutation/* useMutation */.D)(TRIGGER_MEMBERSHIP_EMAIL);
    const { setHasUnsavedChanges  } = useOrganisationContext();
    const { data , loading , error , refetch  } = (0,useQuery/* useQuery */.a)(getMembershipOptionsForOrganisation/* GET_MEMBERSHIP_FOR_ORGANISATION */.o, {
        variables: {
            data: profile === null || profile === void 0 ? void 0 : profile.company
        },
        skip: !(profile === null || profile === void 0 ? void 0 : profile.company) || !isOrganizer
    });
    const [membershipData, setMembershipData] = (0,react.useState)();
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    (0,react.useEffect)(()=>{
        // console.log({ data, loading, error })
        if ((data === null || data === void 0 ? void 0 : data.getMembershipForOrganisation.__typename) === "APIError") {
            errorHandler(data.getMembershipForOrganisation.code)(data.getMembershipForOrganisation.error, data.getMembershipForOrganisation.code);
            setIsLoading(false);
            saveEnabled.current = true;
        }
        if (data && data.getMembershipForOrganisation.__typename === "GetMembershipOutput") {
            const { title , thumbnailImage , bannerImage , description , shortDescription , emailTemplates , isPublished , confirmationText  } = data.getMembershipForOrganisation.details;
            // console.log({ description })
            setMembershipData({
                title,
                thumbnailImage,
                bannerImage,
                description,
                shortDescription,
                emailTemplates,
                isPublished,
                confirmationText
            });
            setDescriptionData(description !== null && description !== void 0 ? description : "Membership Description");
            const { name , prices  } = data.getMembershipForOrganisation.product;
            setProductData({
                prices: prices.map((m)=>({
                        ...m,
                        priceAmount: m.priceAmount / 100
                    })),
                name: name !== null && name !== void 0 ? name : title,
                organisationName: profile === null || profile === void 0 ? void 0 : profile.company
            });
            setIsLoading(false);
            saveEnabled.current = true;
        }
    }, [
        data,
        loading,
        error,
        profile
    ]);
    const errorHandler = function(id) {
        let alert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (message, testId)=>{
            const payload = [
                ...errors
            ];
            const hasError = !!message || message !== "";
            const isCleared = payload.find((f)=>f.eleId === testId) && !hasError;
            if (isCleared) return setErrors(payload.filter((f)=>f.eleId !== testId));
            const isDuplicate = !!payload.find((p)=>p.eleId === testId);
            const newError = {
                step: id !== null && id !== void 0 ? id : "unknown",
                message,
                eleId: testId,
                alert
            };
            if (!isDuplicate && hasError) setErrors([
                ...payload,
                newError
            ]);
        };
    };
    const handleCreateProduct = async ()=>{
        // console.log({ productData })
        if (!!productData) {
            const { prices , organisationName , name  } = productData;
            var ref;
            const res = await createMembership({
                variables: {
                    data: {
                        organisationName: organisationName !== null && organisationName !== void 0 ? organisationName : orgProfile.name,
                        prices: prices.map((m)=>({
                                priceAmount: m.priceAmount * 100,
                                interval: m.interval,
                                currency: m.currency,
                                title: m.title,
                                pillText: m.pillText,
                                priceId: m.priceId
                            })),
                        name: (ref = name !== null && name !== void 0 ? name : membershipData === null || membershipData === void 0 ? void 0 : membershipData.title) !== null && ref !== void 0 ? ref : "".concat(orgProfile.name, "'s Membership")
                    }
                }
            }).then((d)=>{
                setProductData((state)=>{
                    var ref;
                    var ref1;
                    const res = ((ref = d.data) === null || ref === void 0 ? void 0 : ref.createMembership.__typename) === "CreateMembershipOutput" ? d.data.createMembership.prices : (ref1 = state === null || state === void 0 ? void 0 : state.prices) !== null && ref1 !== void 0 ? ref1 : [];
                    const payload = {
                        ...state,
                        prices: prices.map((p)=>{
                            var ref;
                            return {
                                ...p,
                                priceId: (ref = res.find((f)=>!!p.priceId ? f.priceId === p.priceId : f.title === p.title)) === null || ref === void 0 ? void 0 : ref.priceId
                            };
                        })
                    };
                    return payload;
                });
            }).then(()=>{
                setHasUnsavedProductChanges(false);
                setHasUnsavedChanges(false);
            });
        }
    };
    const saveForm = (0,react.useCallback)((0,util/* debounce */.Ds)((payload)=>{
        if (payload) updateMembership({
            variables: {
                data: payload
            }
        }).then((res)=>{
            var ref;
            if (((ref = res.data) === null || ref === void 0 ? void 0 : ref.updateMembership.__typename) !== "APIError") {
                var ref1;
                if ((ref1 = res.data) === null || ref1 === void 0 ? void 0 : ref1.updateMembership.success) (0,dist/* default */.ZP)("Saved", {
                    icon: "✔ ",
                    duration: 1000,
                    className: "custom-toast"
                });
                else {
                    (0,dist/* default */.ZP)("Save Issue", {
                        icon: "⚠ ",
                        duration: 3000,
                        className: "custom-toast"
                    });
                    (0,dist/* default */.ZP)("Saved data to clipboard.", {
                        icon: "⚠ ",
                        duration: 8000,
                        className: "custom-toast"
                    });
                    window.navigator.clipboard.writeText(JSON.stringify(payload, null, 2));
                }
            }
        });
    }, 1000), []);
    (0,react.useEffect)(()=>{
        const payload = (0,util/* cleanGqlPayload */.GR)({
            title: membershipData === null || membershipData === void 0 ? void 0 : membershipData.title,
            description: membershipData === null || membershipData === void 0 ? void 0 : membershipData.description,
            thumbnailImage: membershipData === null || membershipData === void 0 ? void 0 : membershipData.thumbnailImage,
            bannerImage: membershipData === null || membershipData === void 0 ? void 0 : membershipData.bannerImage,
            shortDescription: membershipData === null || membershipData === void 0 ? void 0 : membershipData.shortDescription,
            confirmationText: membershipData === null || membershipData === void 0 ? void 0 : membershipData.confirmationText,
            emailTemplates: membershipData === null || membershipData === void 0 ? void 0 : membershipData.emailTemplates
        });
        // console.log({ payload, saveEnabled: saveEnabled.current })
        if (payload && saveEnabled.current) saveForm(payload);
    }, [
        membershipData,
        saveEnabled,
        saveForm
    ]);
    //
    //
    //INFO Modals
    const emailBuilderModal = (0,react.useMemo)(()=>{
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showEmailModal,
            setShow: setShowEmailModal,
            title: "".concat((emailModalData === null || emailModalData === void 0 ? void 0 : emailModalData.editIndex) !== undefined || emailModalData.editIndex === 0 ? "Edit" : "Create", " Email"),
            className: "flex overflow-visible w-full flex-col justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(email_builder/* default */.ZP, {
                    onSubmit: (data)=>{
                        // console.log({ data })
                        setEmailModalData(data);
                    },
                    enablePreview: true,
                    setError: errorHandler("email_builder"),
                    template: emailModalData,
                    decorators: TextEditorUtil/* EditorMembershipCustomDecorators */.Of,
                    data: membershipData,
                    type: "membership",
                    cacheScopeId: profile === null || profile === void 0 ? void 0 : profile.company
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    className: "mb-4 ml-auto",
                    title: "Save Email",
                    type: "primary",
                    onClick: (e)=>{
                        var ref;
                        e.preventDefault();
                        // console.log({
                        //   templates: membershipData?.emailTemplates,
                        //   emailModalData,
                        // })
                        let payload = {
                            ...membershipData
                        };
                        const hasRegistrationConfirmationTemplate = !!(payload === null || payload === void 0 ? void 0 : (ref = payload.emailTemplates) === null || ref === void 0 ? void 0 : ref.find((f)=>f.trigger === graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation));
                        const newEmail = {
                            title: emailModalData.title,
                            enabled: true,
                            trigger: emailModalData.trigger,
                            data: emailModalData.data,
                            content: emailModalData.content
                        };
                        if (!payload.emailTemplates) payload.emailTemplates = [];
                        if (newEmail.trigger === graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation && hasRegistrationConfirmationTemplate) payload = {
                            ...payload,
                            emailTemplates: [
                                ...payload.emailTemplates.map((m)=>({
                                        title: m.title,
                                        content: m.content,
                                        data: m.data,
                                        enabled: m.enabled,
                                        trigger: graphql/* EventEmailTrigger.Manual */.bQ.Manual
                                    }))
                            ]
                        };
                        if (!!payload.emailTemplates) {
                            if (emailModalData.editIndex === 0 || emailModalData.editIndex) payload.emailTemplates = payload.emailTemplates.map((m, i)=>{
                                if (emailModalData.editIndex === i) return newEmail;
                                return m;
                            });
                            else payload.emailTemplates = [
                                ...payload.emailTemplates,
                                newEmail
                            ];
                        }
                        console.log({
                            payload
                        });
                        setMembershipData(payload);
                        (0,email_builder/* clearEmailContentCache */.ok)({
                            type: "membership",
                            scopeId: profile === null || profile === void 0 ? void 0 : profile.company,
                            template: emailModalData
                        });
                        setShowEmailModal(false);
                        setEmailModalData({});
                    }
                })
            ]
        });
    }, [
        membershipData,
        showEmailModal,
        emailModalData
    ]);
    const [actionLoading, setActionLoading] = (0,react.useState)(false);
    var _currency, ref6;
    const priceModal = (0,react.useMemo)(()=>{
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
            show: showPriceModal,
            setShow: setShowPriceModal,
            title: "".concat((priceModalData === null || priceModalData === void 0 ? void 0 : priceModalData.editIndex) !== undefined || (priceModalData === null || priceModalData === void 0 ? void 0 : priceModalData.editIndex) === 0 ? "Edit" : "Create", " Price"),
            className: "flex overflow-visible w-full flex-col justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                    tooltip: "Price Option Title",
                    testid: "name-input",
                    validations: {
                        maxLength: {
                            value: 30,
                            message: "Title must be 30 characters or less"
                        }
                    },
                    hint: "(Maximum of 30 characters)",
                    label: "Title",
                    className: "flex-1 mr-2",
                    value: priceModalData === null || priceModalData === void 0 ? void 0 : priceModalData.title,
                    onChange: (data)=>{
                        setPriceModalData((state)=>({
                                ...state,
                                title: data
                            }));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                    tooltip: "Price Pill Title",
                    testid: "price-pill-input",
                    validations: {
                        maxLength: {
                            value: 15,
                            message: "Title must be 15 characters or less"
                        }
                    },
                    hint: "What shows on the membership pricing option inside of the colored pill shaped section.",
                    label: "Pill Text",
                    className: "flex-1 mr-2",
                    value: priceModalData === null || priceModalData === void 0 ? void 0 : priceModalData.pillText,
                    onChange: (data)=>{
                        setPriceModalData((state)=>({
                                ...state,
                                pillText: data
                            }));
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceInput/* PriceInput */.t, {
                    hint: "Amount",
                    className: "w-full",
                    currencySymbol: currencies/* default */.Z[(_currency = orgProfile.currency) !== null && _currency !== void 0 ? _currency : "GBP"].symbol,
                    onChange: (data)=>{
                        setPriceModalData((state)=>({
                                ...state,
                                priceAmount: data
                            }));
                    },
                    value: (ref6 = priceModalData === null || priceModalData === void 0 ? void 0 : priceModalData.priceAmount) !== null && ref6 !== void 0 ? ref6 : 0
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownInput/* DropdownInput */.f, {
                    value: priceModalData === null || priceModalData === void 0 ? void 0 : priceModalData.interval,
                    onChange: (data)=>setPriceModalData((state)=>({
                                ...state,
                                interval: data
                            })),
                    options: [
                        {
                            label: "Monthly",
                            value: "month"
                        },
                        {
                            label: "Annually",
                            value: "year"
                        }
                    ],
                    label: "Select a payment interval",
                    className: "w-full sm:w-1/2 lg:w-1/4 "
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    className: "mb-4 ml-auto",
                    title: "Save Price",
                    type: "primary",
                    onClick: (e)=>{
                        e.preventDefault();
                        var ref, ref1, ref2;
                        const pricePayload = {
                            priceAmount: (ref = priceModalData === null || priceModalData === void 0 ? void 0 : priceModalData.priceAmount) !== null && ref !== void 0 ? ref : 10,
                            currency: orgProfile.currency,
                            interval: (ref1 = priceModalData === null || priceModalData === void 0 ? void 0 : priceModalData.interval) !== null && ref1 !== void 0 ? ref1 : "month",
                            title: (ref2 = priceModalData === null || priceModalData === void 0 ? void 0 : priceModalData.title) !== null && ref2 !== void 0 ? ref2 : "Membership",
                            pillText: priceModalData === null || priceModalData === void 0 ? void 0 : priceModalData.pillText
                        };
                        var ref3;
                        let payload = {
                            ...productData,
                            prices: (ref3 = productData === null || productData === void 0 ? void 0 : productData.prices) !== null && ref3 !== void 0 ? ref3 : []
                        };
                        if (!!priceModalData) {
                            if (priceModalData.editIndex === 0 || (priceModalData === null || priceModalData === void 0 ? void 0 : priceModalData.editIndex)) payload.prices[priceModalData.editIndex] = pricePayload;
                            else payload.prices.push(pricePayload);
                        }
                        // console.log({ payload })
                        // setMembershipData(payload)
                        setProductData(payload);
                        setShowPriceModal(false);
                        setHasUnsavedProductChanges(true);
                        setHasUnsavedChanges(true);
                        setPriceModalData({});
                    }
                })
            ]
        });
    }, [
        productData,
        showPriceModal,
        priceModalData
    ]);
    const [tab, setTab] = (0,react.useState)("form");
    const [showCompletedPreview, setShowCompletedPreview] = (0,react.useState)(false);
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
        className: "mt-1 mx-auto",
        size: "medium"
    });
    var ref7, ref8, _currency1, ref9, ref10;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs */.m, {
                activeTitle: tab,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tab */.O, {
                        title: "form",
                        children: [
                            emailBuilderModal,
                            priceModal,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                confirmationModal: {
                                    title: "Confirm Publish Membership",
                                    content: "Are you sure you want to publish this membership? This cannot be undone."
                                },
                                onClick: ()=>{
                                    if (isAdmin || isOrganizer) {
                                        updateMembership({
                                            variables: {
                                                data: {
                                                    isPublished: true
                                                }
                                            }
                                        }).then(()=>refetch());
                                    }
                                },
                                title: (membershipData === null || membershipData === void 0 ? void 0 : membershipData.isPublished) ? "Published" : "Publish Membership",
                                type: "success",
                                size: "medium",
                                disabled: (ref7 = membershipData === null || membershipData === void 0 ? void 0 : membershipData.isPublished) !== null && ref7 !== void 0 ? ref7 : false,
                                className: "ml-auto mr-4 min-w-[110px]",
                                isInConfirmationModal: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                className: "mt-6",
                                title: "Membership Details",
                                initiallyOpen: false,
                                error: (ref = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "INVALID_MEMBERSHIP_DETAILS")) === null || ref === void 0 ? void 0 : ref.message,
                                show: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "flex flex-col items-center mt-14 text-white w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "flex w-full space-x-12",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                            className: "w-full",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "flex flex-col w-full -mb-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                                            tooltip: "Event title is required to publish",
                                                            testid: "name-input",
                                                            validations: {
                                                                maxLength: {
                                                                    value: 150,
                                                                    message: "Title must be 150 characters or less"
                                                                }
                                                            },
                                                            hint: "(Maximum of 150 characters)",
                                                            label: "Title",
                                                            className: "flex-1 mr-2",
                                                            value: membershipData === null || membershipData === void 0 ? void 0 : membershipData.title,
                                                            onChange: (data)=>{
                                                                setMembershipData((state)=>({
                                                                        ...state,
                                                                        title: data
                                                                    }));
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                                            tooltip: "A short event description is required to publish",
                                                            testid: "short-description-input",
                                                            validations: {
                                                                maxLength: {
                                                                    value: 300,
                                                                    message: "Description must be 300 characters or less"
                                                                }
                                                            },
                                                            setError: errorHandler("event"),
                                                            hint: "(Maximum of 300 characters)",
                                                            label: "Short Description",
                                                            className: "flex-1 ml-2 sm:ml-0 mt-1",
                                                            value: membershipData === null || membershipData === void 0 ? void 0 : membershipData.shortDescription,
                                                            onChange: (data)=>{
                                                                setMembershipData((state)=>({
                                                                        ...state !== null && state !== void 0 ? state : {},
                                                                        shortDescription: data
                                                                    }));
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextEditor/* default */.Z, {
                                                    tooltip: "A full description of your membership programme.",
                                                    testid: "description-input",
                                                    className: "mt-2",
                                                    setError: errorHandler("event"),
                                                    label: "Description",
                                                    placeholder: "Write all of the details of your membership...",
                                                    value: membershipData === null || membershipData === void 0 ? void 0 : membershipData.description,
                                                    onChange: (jsonString)=>{
                                                        if ((membershipData === null || membershipData === void 0 ? void 0 : membershipData.description) !== jsonString) setMembershipData((state)=>({
                                                                ...state,
                                                                description: jsonString
                                                            }));
                                                    // setDescriptionData(jsonString)
                                                    }
                                                }, "membership_rich_editor_descripiton"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextEditor/* default */.Z, {
                                                    tooltip: "The text that appears on the confirmation screen after a membership is purchased.",
                                                    testid: "confirmation-text-input",
                                                    className: "mt-2",
                                                    setError: errorHandler("event"),
                                                    label: "Confirmation Text",
                                                    placeholder: "Write the text displayed on the membership confirmation screen",
                                                    value: membershipData === null || membershipData === void 0 ? void 0 : membershipData.confirmationText,
                                                    onChange: (jsonString)=>{
                                                        if ((membershipData === null || membershipData === void 0 ? void 0 : membershipData.confirmationText) !== jsonString) setMembershipData((state)=>({
                                                                ...state,
                                                                confirmationText: jsonString
                                                            }));
                                                    // setDescriptionData(jsonString)
                                                    }
                                                }, "membership_rich_editor_confirmation"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                    className: "flex flex-wrap mt-2",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FileInput/* FileInput */.S, {
                                                            uploadFile: uploadFile,
                                                            label: "Banner Image",
                                                            hint: "recommended size (1200x400).",
                                                            crop: true,
                                                            cropAspectRatio: 4,
                                                            cropShape: "rect",
                                                            testid: "banner-upload",
                                                            value: membershipData === null || membershipData === void 0 ? void 0 : membershipData.bannerImage,
                                                            onChange: (data)=>{
                                                                setMembershipData((state)=>({
                                                                        ...state,
                                                                        bannerImage: data
                                                                    }));
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FileInput/* FileInput */.S, {
                                                            uploadFile: uploadFile,
                                                            label: "Thumbnail Image",
                                                            crop: true,
                                                            hint: "recommended size (400x400).",
                                                            cropAspectRatio: 1,
                                                            cropShape: "rect",
                                                            "data-testid": "thumbnail-upload",
                                                            value: membershipData === null || membershipData === void 0 ? void 0 : membershipData.thumbnailImage,
                                                            onChange: (data)=>{
                                                                setMembershipData((state)=>({
                                                                        ...state,
                                                                        thumbnailImage: data
                                                                    }));
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, "membership_details_section"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                className: "mt-6",
                                title: "Membership Options",
                                initiallyOpen: false,
                                error: (ref1 = errors === null || errors === void 0 ? void 0 : errors.find((e)=>e.step === "INVALID_PRODUCT")) === null || ref1 === void 0 ? void 0 : ref1.message,
                                show: true,
                                showSaveButton: hasUnsavedProductChanges,
                                onSaveClicked: async ()=>{
                                    await handleCreateProduct();
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "flex items-center space-x-2 mb-4 mt-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "text-xl",
                                                children: "Purchase Options"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "text-lg",
                                                children: "After changing your membership pricing options, save them by clicking the Save button in the top-right corner of this section."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                onClick: ()=>{
                                                    // setEmailModalData({
                                                    //   title: `Email Template ${membershipData?.?.length ?? 1}`,
                                                    //   trigger:
                                                    //     (membershipData?.emailTemplates?.length ?? 0) > 0
                                                    //       ? EventEmailTrigger.Manual
                                                    //       : EventEmailTrigger.Confirmation,
                                                    // })
                                                    setPriceModalData({});
                                                    setShowPriceModal(true);
                                                },
                                                title: "Create purchase option",
                                                type: "secondary",
                                                size: "small"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                                        sortable: true,
                                        items: (ref8 = productData === null || productData === void 0 ? void 0 : productData.prices) !== null && ref8 !== void 0 ? ref8 : undefined,
                                        onSort: (e)=>{
                                            // console.log({ e })
                                            const payload = {
                                                ...membershipData,
                                                emailTemplates: e
                                            };
                                            setProductData((state)=>({
                                                    ...state,
                                                    prices: e
                                                }));
                                        },
                                        tableHeading: [
                                            "Title",
                                            "Interval",
                                            "Price",
                                            ""
                                        ],
                                        rows: productData === null || productData === void 0 ? void 0 : (ref2 = productData.prices) === null || ref2 === void 0 ? void 0 : ref2.map((price, index)=>{
                                            return [
                                                "".concat(price.title),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "rounded-md",
                                                    children: price.interval.toUpperCase()
                                                }, "notification-status-".concat(index)),
                                                "".concat(currencies/* default */.Z[(_currency1 = orgProfile.currency) !== null && _currency1 !== void 0 ? _currency1 : "GBP"].symbol).concat(price.priceAmount),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRowActions/* default */.Z, {
                                                    editClicked: ()=>{
                                                        // console.log({ price, index })
                                                        setPriceModalData({
                                                            ...price,
                                                            editIndex: index
                                                        });
                                                        setShowPriceModal(true);
                                                    },
                                                    deleteClicked: ()=>{
                                                        setProductData((state)=>{
                                                            var ref;
                                                            return {
                                                                ...state,
                                                                prices: state === null || state === void 0 ? void 0 : (ref = state.prices) === null || ref === void 0 ? void 0 : ref.filter((_, i)=>i !== index)
                                                            };
                                                        });
                                                    }
                                                }, index)
                                            ];
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        show: (productData === null || productData === void 0 ? void 0 : (ref3 = productData.prices) === null || ref3 === void 0 ? void 0 : ref3.length) === 0,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mt-8 text-center mb-8",
                                            children: "No purchase options have been created yet"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                className: "mt-4",
                                title: "Emails",
                                initiallyOpen: false,
                                // error={errors?.find((e) => e.step === 'API_ERROR')?.message}
                                show: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "flex items-center space-x-2 mb-4 mt-6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "text-xl",
                                                children: "Membership Emails"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                onClick: ()=>{
                                                    var ref, ref1;
                                                    var ref2, ref3;
                                                    setEmailModalData({
                                                        title: "Email Template ".concat((ref2 = membershipData === null || membershipData === void 0 ? void 0 : (ref = membershipData.emailTemplates) === null || ref === void 0 ? void 0 : ref.length) !== null && ref2 !== void 0 ? ref2 : 1),
                                                        trigger: ((ref3 = membershipData === null || membershipData === void 0 ? void 0 : (ref1 = membershipData.emailTemplates) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref3 !== void 0 ? ref3 : 0) > 0 ? graphql/* EventEmailTrigger.Manual */.bQ.Manual : graphql/* EventEmailTrigger.Confirmation */.bQ.Confirmation
                                                    });
                                                    setShowEmailModal(true);
                                                },
                                                title: "Create New Email",
                                                type: "secondary",
                                                size: "small"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                                        sortable: true,
                                        items: (ref9 = membershipData === null || membershipData === void 0 ? void 0 : membershipData.emailTemplates) !== null && ref9 !== void 0 ? ref9 : undefined,
                                        onSort: (e)=>{
                                            // console.log({ e })
                                            const payload = {
                                                ...membershipData,
                                                emailTemplates: e
                                            };
                                            setMembershipData(payload);
                                        },
                                        tableHeading: [
                                            "Subject",
                                            "Trigger",
                                            "Date Sent",
                                            ""
                                        ],
                                        rows: membershipData === null || membershipData === void 0 ? void 0 : (ref4 = membershipData.emailTemplates) === null || ref4 === void 0 ? void 0 : ref4.map((emailTemplates, index)=>{
                                            var ref;
                                            return [
                                                (ref10 = emailTemplates === null || emailTemplates === void 0 ? void 0 : (ref = emailTemplates.title) === null || ref === void 0 ? void 0 : ref.toUpperCase()) !== null && ref10 !== void 0 ? ref10 : "No Title (".concat(index, ")"),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                    className: "rounded-md",
                                                    children: emailTemplates.trigger
                                                }, "notification-status-".concat(index)),
                                                emailTemplates.sentDateTime ? moment_default()(emailTemplates.sentDateTime).format("D MMMM YYYY, h:mm A").toString() : emailTemplates.trigger === graphql/* EventEmailTrigger.Manual */.bQ.Manual ? "Not Sent" : "",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRowActions/* default */.Z, {
                                                    action: [
                                                        {
                                                            title: "Send",
                                                            show: emailTemplates.trigger === graphql/* EventEmailTrigger.Manual */.bQ.Manual,
                                                            loading: actionLoading,
                                                            onClicked: ()=>{
                                                                if (!!orgProfile.name && !!emailTemplates.title) {
                                                                    setActionLoading(true);
                                                                    triggerMail({
                                                                        variables: {
                                                                            orgName: orgProfile.name,
                                                                            template: emailTemplates.title
                                                                        }
                                                                    }).then(()=>{
                                                                        refetch();
                                                                    }).finally(()=>setActionLoading(false));
                                                                }
                                                            },
                                                            confirmModal: {
                                                                title: "Are you sure?",
                                                                content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                    className: "pt-6 pb-6",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                            className: "my-2 mb-6",
                                                                            children: "Are you sure you want to send this email to all attendees? Please ensure your email template is correct before confirming."
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                            className: "h-[50vh]",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(emailPreview/* EmailPreview */.M, {
                                                                                resizeEnabled: false,
                                                                                content: emailTemplates.content,
                                                                                type: "membership",
                                                                                data: membershipData
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }
                                                        }
                                                    ],
                                                    editClicked: ()=>{
                                                        // console.log({ emailTemplates, index })
                                                        setEmailModalData({
                                                            ...emailTemplates,
                                                            editIndex: index
                                                        });
                                                        setShowEmailModal(true);
                                                    },
                                                    deleteClicked: ()=>{
                                                        var ref;
                                                        setMembershipData({
                                                            ...membershipData,
                                                            emailTemplates: membershipData === null || membershipData === void 0 ? void 0 : (ref = membershipData.emailTemplates) === null || ref === void 0 ? void 0 : ref.filter((_, i)=>i !== index)
                                                        });
                                                    }
                                                }, index)
                                            ];
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        show: (membershipData === null || membershipData === void 0 ? void 0 : (ref5 = membershipData.emailTemplates) === null || ref5 === void 0 ? void 0 : ref5.length) === 0,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                            className: "text-sm mt-8 text-center mb-8",
                                            children: "No event emails have been created yet"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "my-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    className: "ml-auto",
                                    title: "Preview Membership",
                                    type: "primary",
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        setTab("preview");
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tab */.O, {
                        title: "preview",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxInput/* CheckboxInput */.I, {
                                value: showCompletedPreview,
                                onChange: (data)=>{
                                    // console.log({ data })
                                    setShowCompletedPreview(data);
                                },
                                className: "bg-transparent rounded text-sm border-box mb-4",
                                border: "",
                                label: "",
                                customStyles: "!justify-start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    children: "Show Confirmation Preview"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "lg:block w-full relative h-full min-h-[65vh] border-forumm-menu-border pb-16",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        ignoreTheme: true,
                                        className: "text-md absolute p-2 bg-white rounded text-black opacity-60",
                                        children: "Preview"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                        className: "w-full h-full rounded border border-white border-solid border-opacity-25 ",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                        },
                                        /* src={`/donation/${formData?.event?.donationUrl}`} */ src: "/membership/".concat(orgProfile.name, "?nav=false&").concat(showCompletedPreview ? "registered" : "reset")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "mt-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            className: "ml-auto",
                                            title: "Back to Editor",
                                            type: "primary",
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                setTab("form");
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Toaster */.x7, {
                toastOptions: {
                    className: "shadow-lg !rounded-full flex items-center border-2 !bg-forumm-white border-forumm-green !text-forumm-green mt-[80px]",
                    duration: 8000
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./libs/Router/useForummRouter.ts + 1 modules
var useForummRouter = __webpack_require__(65676);
// EXTERNAL MODULE: ./libs/Stripe/util.ts + 1 modules
var Stripe_util = __webpack_require__(16458);
// EXTERNAL MODULE: ./graphql/payment/paymentSettings.ts
var paymentSettings = __webpack_require__(99591);
;// CONCATENATED MODULE: ./components/organisation/OrganisationSettings/OrganisationSettings.tsx































var OrganisationPageTabs;
(function(OrganisationPageTabs) {
    OrganisationPageTabs[OrganisationPageTabs["Settings"] = 0] = "Settings";
    OrganisationPageTabs[OrganisationPageTabs["Payments"] = 1] = "Payments";
    OrganisationPageTabs[OrganisationPageTabs["Membership"] = 2] = "Membership";
    OrganisationPageTabs[OrganisationPageTabs["Members"] = 3] = "Members";
    OrganisationPageTabs[OrganisationPageTabs["Orders"] = 4] = "Orders";
    OrganisationPageTabs[OrganisationPageTabs["Organisers"] = 5] = "Organisers";
})(OrganisationPageTabs || (OrganisationPageTabs = {}));
const ZAPIER_PUBLIC_INVITE_LINK = "https://zapier.com/developer/public-invite/242575/81ee6956a1ccda1298c683c42b0ebe31/";
const StripeStatusRow = (param)=>/*#__PURE__*/ {
    let { label , complete  } = param;
    return (0,jsx_runtime.jsxs)(Box["default"], {
        className: "flex items-center justify-between rounded-lg border border-forumm-menu-border px-4 py-3 text-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "font-medium",
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex items-center gap-2 font-semibold ".concat(complete ? "text-forumm-green" : "text-forumm-orange"),
                children: [
                    complete ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiCheckCircle */.wRn, {
                        className: "h-5 w-5"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiErrorCircle */.Cw1, {
                        className: "h-5 w-5"
                    }),
                    complete ? "Complete" : "Required"
                ]
            })
        ]
    });
};
function OrganisationSettings(param) {
    let { name  } = param;
    var ref, ref1, ref2;
    const goCardlessEnabled = (0,paymentFeatureFlags/* isGoCardlessEnabled */.w)();
    const uploadFile = (0,useFileUploader/* default */.Z)();
    const { initiateOAuth , onCallback , accessToken , completed  } = (0,useBlackBaud/* useBlackBaud */.M)();
    const [updateOrganisation] = (0,useMutation/* useMutation */.D)(organisation_updateOrganisation/* UPDATE_ORGANISATION */.$);
    const [logo, setLogo] = (0,react.useState)();
    const [mainColour, setMainColour] = (0,react.useState)();
    const [orgCurrency, setOrgcurrency] = (0,react.useState)("GBP");
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [updated, setUpdated] = (0,react.useState)(false);
    const callbackExecutedRef = (0,react.useRef)(false);
    const { updateHighlightColour  } = (0,useTheme/* useTheme */.Fg)();
    const { isOrganizer , isAdmin , profile  } = (0,useAuth/* useAuth */.aC)();
    const router = (0,next_router.useRouter)();
    const [routerModal, { setRouteError  }] = (0,useForummRouter/* default */.ZP)();
    const orgctx = InitialiseOrganisationContext();
    if (!!router && !!router.events) {
        router.events.on("routeChangeStart", (url)=>{
            if (orgctx.hasUnsavedChanges) setRouteError(useForummRouter/* ForummRouterEvents.MembershipPriceUnsaved */.fp.MembershipPriceUnsaved, url);
        });
    }
    const [tab, setTab] = (0,react.useState)(OrganisationPageTabs.Settings);
    if (!isOrganizer && !isAdmin) {
        router.push("/");
    }
    const { data: organisationData  } = (0,useQuery/* useQuery */.a)(getOrganisationByName/* GET_ORGANISATION_BY_NAME */.g, {
        variables: {
            name
        },
        skip: !name
    });
    (0,react.useEffect)(()=>{
        if (organisationData === null || organisationData === void 0 ? void 0 : organisationData.getOrganisationByName) {
            const { mainColour: currentMainColour , logoImage , currency  } = organisationData === null || organisationData === void 0 ? void 0 : organisationData.getOrganisationByName;
            if (logoImage) setLogo(logoImage);
            if (currentMainColour) setMainColour(currentMainColour);
            if (currency) setOrgcurrency(currency);
        }
    }, [
        organisationData
    ]);
    (0,react.useEffect)(()=>{
        // Check if the URL contains the OAuth callback parameters
        if (window.location.search.includes("code") && window.location.search.includes("state")) {
            if (callbackExecutedRef.current) return;
            callbackExecutedRef.current = true;
            const lastEventEdited = window.localStorage.getItem("Forumm_LastEventEdited");
            const onCompleteAction = ()=>{
                if (lastEventEdited) {
                    window.localStorage.removeItem("Forumm_LastEventEdited");
                    router.push("/create-event?id=".concat(lastEventEdited));
                }
            };
            const msg = lastEventEdited ? "All set! Heading back to your event…" : "Your account was linked!";
            (0,dist/* toast */.Am)(msg, {
                icon: "\uD83C\uDF89",
                duration: 3000
            });
            onCallback(window.location.href, name, onCompleteAction);
        }
    }, [
        onCallback,
        name
    ]);
    const handleUpdateOrganisation = async ()=>{
        const variables = {
            name,
            mainColour,
            logoImage: logo,
            currency: orgCurrency
        };
        if (typeof logo === "string") {
            variables.logoImage = logo;
        }
        setIsLoading(true);
        await updateOrganisation({
            variables
        });
        setIsLoading(false);
        if (variables.mainColour !== undefined && updateHighlightColour) {
            updateHighlightColour(variables === null || variables === void 0 ? void 0 : variables.mainColour);
        }
        setUpdated(true);
        setTimeout(()=>{
            setUpdated(false);
        }, 3000);
    };
    const handleBlackBaud = ()=>{
        initiateOAuth();
    };
    const publicUrl = window.location.origin + "/org/" + (organisationData === null || organisationData === void 0 ? void 0 : (ref = organisationData.getOrganisationByName) === null || ref === void 0 ? void 0 : ref.url);
    const previewLogo = typeof logo === "string" ? logo : "/images/ForummLogo.svg";
    const connectedToBlackBaud = completed || (organisationData === null || organisationData === void 0 ? void 0 : (ref1 = organisationData.getOrganisationByName) === null || ref1 === void 0 ? void 0 : ref1.blackBaudIsSet);
    const [errors, setErrors] = (0,react.useState)(undefined);
    const { data: merchantQueryData , refetch: refetchMerchant  } = (0,useQuery/* useQuery */.a)(GET_IS_MERCHANT, {
        variables: {
            input: {
                userId: profile === null || profile === void 0 ? void 0 : profile.userId,
                company: name
            }
        },
        skip: !(profile === null || profile === void 0 ? void 0 : profile.userId)
    });
    const merchantData = (0,Stripe_util/* getStripeConnectStatus */.T3)(merchantQueryData === null || merchantQueryData === void 0 ? void 0 : merchantQueryData.getMerchantAccount);
    const { data: paymentSettingsData , loading: paymentSettingsLoading , refetch: refetchPaymentSettings  } = (0,useQuery/* useQuery */.a)(paymentSettings/* GET_PAYMENT_SETTINGS */.QF, {
        skip: !(profile === null || profile === void 0 ? void 0 : profile.userId)
    });
    const [createPaymentProcessorConnectLink] = (0,useMutation/* useMutation */.D)(paymentSettings/* CREATE_PAYMENT_PROCESSOR_CONNECT_LINK */.n_);
    const [getDisconnectImpact] = (0,useLazyQuery/* useLazyQuery */.t)(paymentSettings/* GET_PAYMENT_PROCESSOR_DISCONNECT_IMPACT */.mR, {
        fetchPolicy: "network-only"
    });
    const [disconnectPaymentProcessor] = (0,useMutation/* useMutation */.D)(paymentSettings/* DISCONNECT_PAYMENT_PROCESSOR */.Pu);
    const { query  } = (0,next_router.useRouter)();
    const [showConfirmationModal, setShowConfirmationModal] = (0,react.useState)(false);
    const [showStripeModal, setShowStripeModal] = (0,react.useState)(false);
    const [isLinkButtonLoading, setLinkButtonLoading] = (0,react.useState)(false);
    const [paymentActionLoading, setPaymentActionLoading] = (0,react.useState)();
    const [zapierToken, setZapierToken] = (0,react.useState)();
    const [zapierActionLoading, setZapierActionLoading] = (0,react.useState)(false);
    const [createZapierApiToken] = (0,useMutation/* useMutation */.D)(CREATE_ZAPIER_API_TOKEN);
    const [revokeZapierIntegration] = (0,useMutation/* useMutation */.D)(REVOKE_ZAPIER_INTEGRATION);
    const { data: zapierStatusData , loading: zapierStatusLoading , refetch: refetchZapierStatus  } = (0,useQuery/* useQuery */.a)(GET_ZAPIER_INTEGRATION_STATUS, {
        variables: {
            name
        },
        skip: !name
    });
    const zapierStatus = zapierStatusData === null || zapierStatusData === void 0 ? void 0 : zapierStatusData.getZapierIntegrationStatus;
    const navItems = Object.entries(OrganisationPageTabs).map((k)=>({
            label: k[0],
            targetStage: k[1]
        })).filter((k)=>typeof k.targetStage === "number");
    const handlePaymentConnect = async (e, processor)=>{
        e.preventDefault();
        setLinkButtonLoading(true);
        setPaymentActionLoading(processor);
        if (!(profile === null || profile === void 0 ? void 0 : profile.userId)) throw new Error("You must be logged in to create a merchant account.");
        await createPaymentProcessorConnectLink({
            variables: {
                processor
            }
        }).then((data)=>{
            var ref;
            if (data.errors) throw data.errors;
            window.location.href = (ref = data.data) === null || ref === void 0 ? void 0 : ref.createPaymentProcessorConnectLink.redirectUrl;
            setLinkButtonLoading(false);
            setPaymentActionLoading(undefined);
        }).catch((err)=>{
            var ref;
            var ref1;
            setErrors({
                message: (ref1 = err === null || err === void 0 ? void 0 : (ref = err[0]) === null || ref === void 0 ? void 0 : ref.message) !== null && ref1 !== void 0 ? ref1 : err === null || err === void 0 ? void 0 : err.message
            });
            setLinkButtonLoading(false);
            setPaymentActionLoading(undefined);
        });
    };
    const handleStripeConnect = (e)=>handlePaymentConnect(e, "STRIPE");
    const handleDisconnectPaymentProcessor = async (processor)=>{
        setPaymentActionLoading(processor);
        try {
            var ref;
            const impactResponse = await getDisconnectImpact({
                variables: {
                    processor
                }
            });
            var ref1;
            const impacted = (ref1 = (ref = impactResponse.data) === null || ref === void 0 ? void 0 : ref.getPaymentProcessorDisconnectImpact) !== null && ref1 !== void 0 ? ref1 : [];
            const eventSummary = impacted.length ? "\n\nAffected live events:\n".concat(impacted.map((event)=>"- ".concat(event.title)).join("\n")) : "\n\nNo live events currently use this processor.";
            if (!window.confirm("Disconnect ".concat(processor === "STRIPE" ? "Stripe" : "GoCardless", "? Active events will automatically switch to another ready processor, or have payments disabled.").concat(eventSummary))) return;
            await disconnectPaymentProcessor({
                variables: {
                    processor
                }
            });
            await Promise.all([
                refetchPaymentSettings(),
                refetchMerchant()
            ]);
            (0,dist/* toast */.Am)("".concat(processor === "STRIPE" ? "Stripe" : "GoCardless", " disconnected."), {
                icon: "✅"
            });
        } catch (error) {
            var ref2;
            (0,dist/* toast */.Am)((ref2 = error === null || error === void 0 ? void 0 : error.message) !== null && ref2 !== void 0 ? ref2 : "Unable to disconnect payment processor.", {
                icon: "❌"
            });
        } finally{
            setPaymentActionLoading(undefined);
        }
    };
    const handleCreateZapierToken = async ()=>{
        setZapierActionLoading(true);
        setZapierToken(undefined);
        try {
            var ref;
            const response = await createZapierApiToken({
                variables: {
                    name
                }
            });
            const result = (ref = response.data) === null || ref === void 0 ? void 0 : ref.createZapierApiToken;
            if (!(result === null || result === void 0 ? void 0 : result.success) || !(result === null || result === void 0 ? void 0 : result.token)) {
                var ref1;
                throw new Error((ref1 = result === null || result === void 0 ? void 0 : result.error) !== null && ref1 !== void 0 ? ref1 : "Unable to create Zapier API key");
            }
            setZapierToken(result.token);
            await refetchZapierStatus();
            (0,dist/* toast */.Am)("Zapier API key created.", {
                icon: "✅",
                duration: 4000
            });
        } catch (error) {
            var ref2;
            (0,dist/* toast */.Am)((ref2 = error === null || error === void 0 ? void 0 : error.message) !== null && ref2 !== void 0 ? ref2 : "Unable to create Zapier API key.", {
                icon: "❌",
                duration: 6000
            });
        } finally{
            setZapierActionLoading(false);
        }
    };
    const handleRevokeZapier = async ()=>{
        setZapierActionLoading(true);
        try {
            var ref, ref1;
            const response = await revokeZapierIntegration({
                variables: {
                    name
                }
            });
            if (!((ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.revokeZapierIntegration) === null || ref1 === void 0 ? void 0 : ref1.success)) {
                throw new Error("Unable to disconnect Zapier");
            }
            setZapierToken(undefined);
            await refetchZapierStatus();
            (0,dist/* toast */.Am)("Zapier disconnected.", {
                icon: "✅",
                duration: 4000
            });
        } catch (error) {
            var ref2;
            (0,dist/* toast */.Am)((ref2 = error === null || error === void 0 ? void 0 : error.message) !== null && ref2 !== void 0 ? ref2 : "Unable to disconnect Zapier.", {
                icon: "❌",
                duration: 6000
            });
        } finally{
            setZapierActionLoading(false);
        }
    };
    const handleCopyZapierToken = async ()=>{
        var ref;
        if (!zapierToken || !((ref = window.navigator) === null || ref === void 0 ? void 0 : ref.clipboard)) return;
        await window.navigator.clipboard.writeText(zapierToken);
        (0,dist/* toast */.Am)("Zapier API key copied.", {
            icon: "✅",
            duration: 3000
        });
    };
    const handleCopyZapierInviteLink = async ()=>{
        var ref;
        if (!((ref = window.navigator) === null || ref === void 0 ? void 0 : ref.clipboard)) return;
        await window.navigator.clipboard.writeText(ZAPIER_PUBLIC_INVITE_LINK);
        (0,dist/* toast */.Am)("Zapier invite link copied.", {
            icon: "✅",
            duration: 3000
        });
    };
    (0,react.useEffect)(()=>{
        if (query.stripeconfirmed === "true") setShowConfirmationModal(true);
    }, [
        query
    ]);
    (0,react.useEffect)(()=>{
        if (query.tab === "payments") setTab(OrganisationPageTabs.Payments);
    }, [
        query.tab
    ]);
    const successModal = /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        title: "Stripe Connect Confirmation",
        show: showConfirmationModal,
        setShow: setShowConfirmationModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "flex flex-col mx-10 text-sm font-light",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex flex-col items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "py-2 flex font-bold text-2xl",
                    children: "You have successfully linked your Stripe account."
                })
            })
        })
    });
    const stripeActionTitle = !merchantData.isMerchant ? "Connect Stripe" : merchantData.isReady ? "View Stripe status" : "Continue Stripe setup";
    const stripeModal = /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        title: "Stripe Settings",
        show: showStripeModal,
        setShow: setShowStripeModal,
        className: "max-w-2xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "flex flex-col gap-5 px-2 pb-3 text-sm",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "text-lg font-semibold",
                            children: merchantData.isReady ? "Stripe is ready for payments" : "Finish Stripe setup to accept payments"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "mt-2 opacity-80",
                            children: "Paid tickets can only be published once Stripe Connect is linked, onboarding is complete, and charges are enabled."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex flex-col gap-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeStatusRow, {
                            label: "Stripe account created",
                            complete: merchantData.isMerchant
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeStatusRow, {
                            label: "Onboarding complete",
                            complete: merchantData.onboardingComplete
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeStatusRow, {
                            label: "Payments activated",
                            complete: merchantData.chargesEnabled
                        })
                    ]
                }),
                !merchantData.isReady && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "flex flex-col gap-3 rounded-lg bg-forumm-blue-2/10 p-4 sm:flex-row sm:items-center sm:justify-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "font-semibold",
                                    children: "Action needed"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "mt-1 opacity-80",
                                    children: "Continue to Stripe to complete the outstanding requirements."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            title: stripeActionTitle,
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiRightArrowAlt */.OEZ, {}),
                            iconPos: "end",
                            buttonType: "button",
                            type: "primary",
                            loading: isLinkButtonLoading,
                            onClick: handleStripeConnect
                        })
                    ]
                })
            ]
        })
    });
    const stripeConnectPanel = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "w-full max-w-md rounded-lg border border-forumm-menu-border p-5 shadow-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex items-start justify-between gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-lg font-semibold",
                                children: "Stripe"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "mt-1 text-sm opacity-80",
                                children: "Link Stripe Connect before publishing events with paid tickets."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "rounded-full px-3 py-1 text-xs font-semibold ".concat(merchantData.isReady ? "bg-forumm-green/10 text-forumm-green" : "bg-forumm-orange/10 text-forumm-orange"),
                        children: merchantData.isReady ? "Ready" : "Setup required"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "mt-4 flex flex-col gap-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeStatusRow, {
                        label: "Account",
                        complete: merchantData.isMerchant
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeStatusRow, {
                        label: "Onboarding",
                        complete: merchantData.onboardingComplete
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StripeStatusRow, {
                        label: "Payments",
                        complete: merchantData.chargesEnabled
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "mt-5 flex flex-col gap-3 sm:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: stripeActionTitle,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiCog */.MBj, {}),
                        iconPos: "end",
                        buttonType: "button",
                        type: merchantData.isReady ? "secondary" : "primary",
                        loading: isLinkButtonLoading,
                        onClick: (e)=>{
                            if (merchantData.isReady) {
                                setShowStripeModal(true);
                                return;
                            }
                            handleStripeConnect(e);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: "Details",
                        buttonType: "button",
                        type: "secondary",
                        onClick: ()=>setShowStripeModal(true)
                    }),
                    merchantData.isMerchant && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: "Disconnect",
                        buttonType: "button",
                        type: "danger",
                        loading: paymentActionLoading === "STRIPE",
                        onClick: ()=>handleDisconnectPaymentProcessor("STRIPE")
                    })
                ]
            })
        ]
    });
    const goCardlessSettings = paymentSettingsData === null || paymentSettingsData === void 0 ? void 0 : (ref2 = paymentSettingsData.getPaymentSettings) === null || ref2 === void 0 ? void 0 : ref2.gocardless;
    const goCardlessConnectPanel = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "w-full max-w-md rounded-lg border border-forumm-menu-border p-5 shadow-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex items-start justify-between gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-lg font-semibold",
                                children: "GoCardless"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "mt-1 text-sm opacity-80",
                                children: "Accept GBP and EUR paid-ticket purchases using Instant Bank Pay."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "rounded-full px-3 py-1 text-xs font-semibold ".concat((goCardlessSettings === null || goCardlessSettings === void 0 ? void 0 : goCardlessSettings.ready) ? "bg-forumm-green/10 text-forumm-green" : "bg-forumm-orange/10 text-forumm-orange"),
                        children: paymentSettingsLoading ? "Checking" : (goCardlessSettings === null || goCardlessSettings === void 0 ? void 0 : goCardlessSettings.ready) ? "Ready" : "Setup required"
                    })
                ]
            }),
            !!(goCardlessSettings === null || goCardlessSettings === void 0 ? void 0 : goCardlessSettings.reason) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "mt-4 rounded-lg border border-forumm-menu-border px-4 py-3 text-sm opacity-80",
                children: goCardlessSettings.reason
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "mt-5 flex flex-col gap-3 sm:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: (goCardlessSettings === null || goCardlessSettings === void 0 ? void 0 : goCardlessSettings.configured) ? "Reconnect GoCardless" : "Connect GoCardless",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiPlug */.yiM, {}),
                        buttonType: "button",
                        type: (goCardlessSettings === null || goCardlessSettings === void 0 ? void 0 : goCardlessSettings.ready) ? "secondary" : "primary",
                        loading: paymentActionLoading === "GOCARDLESS",
                        onClick: (event)=>handlePaymentConnect(event, "GOCARDLESS")
                    }),
                    (goCardlessSettings === null || goCardlessSettings === void 0 ? void 0 : goCardlessSettings.configured) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: "Disconnect",
                        buttonType: "button",
                        type: "danger",
                        loading: paymentActionLoading === "GOCARDLESS",
                        onClick: ()=>handleDisconnectPaymentProcessor("GOCARDLESS")
                    })
                ]
            })
        ]
    });
    const zapierStatusLabel = zapierStatusLoading ? "Loading" : (zapierStatus === null || zapierStatus === void 0 ? void 0 : zapierStatus.connected) ? "Connected" : (zapierStatus === null || zapierStatus === void 0 ? void 0 : zapierStatus.hasApiToken) ? "API key active" : "Not connected";
    const zapierStatusReady = !!(zapierStatus === null || zapierStatus === void 0 ? void 0 : zapierStatus.hasApiToken);
    var _tokenLastFour, _activeSubscriptionCount;
    const zapierConnectPanel = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "mt-6 w-full max-w-md rounded-lg border border-forumm-menu-border p-5 shadow-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex items-start justify-between gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-lg font-semibold",
                                children: "Zapier"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "mt-1 text-sm opacity-80",
                                children: "Send registration and attendance updates to Zapier."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "rounded-full px-3 py-1 text-xs font-semibold ".concat(zapierStatusReady ? "bg-forumm-green/10 text-forumm-green" : "bg-forumm-orange/10 text-forumm-orange"),
                        children: zapierStatusLabel
                    })
                ]
            }),
            !!(zapierStatus === null || zapierStatus === void 0 ? void 0 : zapierStatus.hasApiToken) && !zapierToken && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "mt-4 rounded-lg border border-forumm-menu-border px-4 py-3 text-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "font-semibold",
                        children: "API key"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "mt-1 opacity-80",
                        children: [
                            "Ending in ",
                            (_tokenLastFour = zapierStatus.tokenLastFour) !== null && _tokenLastFour !== void 0 ? _tokenLastFour : "unknown"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "mt-1 opacity-80",
                        children: [
                            "Active Zapier hooks: ",
                            (_activeSubscriptionCount = zapierStatus.activeSubscriptionCount) !== null && _activeSubscriptionCount !== void 0 ? _activeSubscriptionCount : 0
                        ]
                    })
                ]
            }),
            !!zapierToken && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "mt-4 rounded-lg border border-forumm-green/40 bg-forumm-green/10 px-4 py-3 text-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "font-semibold",
                        children: "New API key"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "mt-2 break-all font-mono text-xs",
                        children: zapierToken
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: "Copy",
                        type: "secondary",
                        size: "small",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiCopy */.LhG, {}),
                        className: "mt-3",
                        onClick: handleCopyZapierToken
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "mt-4 rounded-lg border border-forumm-menu-border px-4 py-3 text-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "font-semibold",
                        children: "Zapier app invite"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "mt-1 opacity-80",
                        children: "Use this invite link to add the Forumm Zapier integration to your Zaps."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "mt-2 break-all font-mono text-xs",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: ZAPIER_PUBLIC_INVITE_LINK,
                            rel: "noreferrer",
                            target: "_blank",
                            children: ZAPIER_PUBLIC_INVITE_LINK
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: "Copy invite link",
                        type: "secondary",
                        size: "small",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiCopy */.LhG, {}),
                        className: "mt-3",
                        onClick: handleCopyZapierInviteLink
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "mt-5 flex flex-col gap-3 sm:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: (zapierStatus === null || zapierStatus === void 0 ? void 0 : zapierStatus.hasApiToken) ? "Generate new key" : "Generate API key",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* BiPlug */.yiM, {}),
                        buttonType: "button",
                        type: "primary",
                        loading: zapierActionLoading || zapierStatusLoading,
                        disabled: zapierActionLoading || zapierStatusLoading,
                        onClick: handleCreateZapierToken
                    }),
                    !!(zapierStatus === null || zapierStatus === void 0 ? void 0 : zapierStatus.hasApiToken) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        title: "Disconnect",
                        buttonType: "button",
                        type: "danger",
                        loading: zapierActionLoading,
                        disabled: zapierActionLoading,
                        onClick: handleRevokeZapier,
                        confirmationModal: {
                            title: "Disconnect Zapier",
                            content: "This revokes all Zapier API keys and disables active Zapier hooks for this organisation."
                        }
                    })
                ]
            })
        ]
    });
    const handleTabChange = (e)=>{
        if (orgctx.hasUnsavedChanges) return setRouteError(useForummRouter/* ForummRouterEvents.MembershipPriceUnsaved */.fp.MembershipPriceUnsaved, "LOCAL", e);
        setTab(e);
    };
    // const handleRouteChange = (event: ForummRouterEvents, tab: any) => {
    //   console.log({ event, tab })
    //   if (event === ForummRouterEvents.MembershipPriceUnsavedConfirmed && !!tab) {
    //     orgctx.setHasUnsavedChanges(false)
    //     setTab(tab)
    //   }
    // }
    //
    // router?.events?.on('routeChangeStart', handleRouteChange)
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganisationContext.Provider, {
        value: orgctx,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
            className: "flex justify-center flex-col md:flex-row mb-10 mt-0 md:mt-20 w-full max-w-[1500px]",
            children: [
                routerModal,
                successModal,
                stripeModal,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(base_SideNav, {
                    className: "justify-center xs:justify-start xs:ml-24 mb-4",
                    navItems: navItems,
                    stage: tab,
                    setStage: handleTabChange
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs */.m, {
                    activeTitle: tab,
                    className: "flex-1 px-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                            title: OrganisationPageTabs.Orders,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderManager, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                            title: OrganisationPageTabs.Membership,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MembershipSettings, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                            title: OrganisationPageTabs.Members,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MemberManager, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                            title: OrganisationPageTabs.Organisers,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganiserManager, {
                                className: "mb-10"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                            title: OrganisationPageTabs.Payments,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "flex flex-col items-center gap-6 mt-14 text-white w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "text-3xl",
                                        children: "Payment Settings"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "text-sm opacity-80 max-w-2xl text-center",
                                        children: goCardlessEnabled ? "Connect one or both processors. Each paid event uses exactly one processor at a time." : "Connect Stripe before publishing events with paid tickets."
                                    }),
                                    stripeConnectPanel,
                                    goCardlessEnabled && goCardlessConnectPanel
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                            title: OrganisationPageTabs.Settings,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "flex flex-col items-center mt-14 text-white w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "text-3xl",
                                        children: "Organisation Settings"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "pt-2 justify-center flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                className: "relative justify-center mb-8",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: previewLogo,
                                                        width: 160,
                                                        height: 160,
                                                        alt: "Profile Image",
                                                        className: "w-40 h-40 bg-contain bg-center rounded-full object-cover mt-8 ml-4"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "absolute top-10 right-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileInput/* FileInput */.S, {
                                                            uploadFile: uploadFile,
                                                            value: logo,
                                                            onChange: (data)=>{
                                                                setLogo(data);
                                                            },
                                                            minified: true
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorPicker/* ColorPicker */.z, {
                                                className: "font-medium",
                                                value: mainColour,
                                                label: "Main Organisation Colour:",
                                                onChange: (newColour)=>{
                                                    setMainColour(newColour);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "pb-2 mt-10",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioFieldInput/* RadioFieldInput */.g, {
                                                    label: "Select currency:",
                                                    testid: "currency-radio",
                                                    options: [
                                                        "USD",
                                                        "CAD",
                                                        "EUR",
                                                        "GBP"
                                                    ],
                                                    className: "font-medium",
                                                    itemClassName: "text-sm mt-4",
                                                    value: orgCurrency,
                                                    onChange: (currency)=>{
                                                        setOrgcurrency(currency);
                                                    }
                                                })
                                            }),
                                            zapierConnectPanel,
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                className: "mt-10",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "font-medium mb-1",
                                                        children: "Organisation Public URL:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            className: "text-[#0052DD]",
                                                            href: publicUrl,
                                                            children: publicUrl
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    updated && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "transition-all !text-white p-4 flex items-center justify-center mt-4 bg-green-400 pointer-events-none rounded text-center",
                                        children: [
                                            "Your organisation has been updated!",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TickIcon/* default */.Z, {
                                                className: "inline-block h-8 w-8 ml-2"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "max-w-md",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                            loading: isLoading,
                                            onClick: handleUpdateOrganisation,
                                            className: "w-full mt-8",
                                            title: "Save Changes"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Toaster */.x7, {
                    toastOptions: {
                        className: "shadow-lg !rounded-full flex items-center border-2 !bg-forumm-white border-forumm-green !text-forumm-green mt-[80px]",
                        duration: 4000
                    }
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./pages/organisation-settings.tsx






function UserDetailsPage() {
    const { profile , isOrganizer , isAdmin , isLogged  } = (0,useAuth/* useAuth */.aC)();
    const { push  } = (0,next_router.useRouter)();
    const [isReady, setIsReady] = (0,react.useState)(false);
    const [isAllowed, setIsAllowed] = (0,react.useState)(undefined);
    // const perms = getPermission('USER::ACCESS_ORGANISATION::*')
    if (!isLogged) push("/login?previous=true");
    (0,react.useEffect)(()=>{
        if (isOrganizer !== undefined && isAdmin !== undefined) {
            setIsReady(true);
            setIsAllowed(isOrganizer || !isAdmin);
        }
    }, [
        isOrganizer,
        isAdmin
    ]);
    (0,react.useEffect)(()=>{
        if (profile && !isOrganizer) push("/dashboard");
    }, [
        isOrganizer,
        profile
    ]);
    (0,react.useEffect)(()=>{
        if (isReady && isAllowed !== undefined && isAllowed == false) push("/");
    }, [
        isReady,
        isAllowed
    ]);
    if (!isReady || !profile || !isOrganizer) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingBar/* default */.Z, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganisationSettings, {
            name: (profile === null || profile === void 0 ? void 0 : profile.company) || (profile === null || profile === void 0 ? void 0 : profile.university) || ""
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,3777,3714,1458,9198,474,4555,7632,9681,6109,9041,8012,9265,788,9460,7585,9774,2888,179], function() { return __webpack_exec__(31318); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);